export function smartCapture() {
  return `<div class="dark-inner-provider-container">
<div>
<form class="camera-options--container no-style">
<select data-jcs-element="camera__select" class="camera-choices camera-choices-half-s camera-choices-full-xs control control--select"></select>
</form>
  <div data-jcs-element="info__journey__action__container" class="camera-capture--caption">
<p data-jcs-element="info__journey__action__text"></p>
</div>
<div class="help-container">
<div class="camera-viewfinder--container">
  <div data-jcs-element="camera__viewfinder__inner__container" class="camera-viewfinder--inner-container" style="position: relative;">
    <canvas data-jcs-element="camera__viewfinder" class="camera-viewfinder" style="position: relative; left: 0; top: 0; z-index: 0;"></canvas>
    <div data-jcs-element="animation__viewfinder" class="camera-viewfinder" style="position: absolute; left: 0; top: 0; z-index: 1;"></div>
    <div data-jcs-element="overlay_viewfinder" class="camera-viewfinder--overlay"></div>
    <div data-jcs-element="overlay_viewfinder" class="camera-viewfinder--overlay--transparent">
      <p class="camera-viewfinder--overlay-text">
          <button data-jcs-element="camera__capture" class="button button--primary camera-button">{{CAMERA_CAPTURE_START_BUTTON}}</button>
      </p>
    </div>
    <svg class="canvas-overlay" data-jcs-element="canvas__condition__error" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="24" cy="24" r="22" fill="white" stroke="#D87212" stroke-width="4" stroke-linecap="round"/>
      <path d="M24 14V26M24 34V33.8972" stroke="#D87212" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <div class="gbg-loader">
      <svg class="circular" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="3" stroke-miterlimit="10" />
      </svg>
      <p>{{PICTURE_VERIFYING}}</p>
    </div>
  </div>
</div>
<div class="uploading--container">
  <span data-jcs-element="camera__condition__uploading" class="camera-condition camera-condition--uploading">{{CAMERA_CONDITION_UPLOADING}}</span>
</div>
<div data-jcs-element="camera__conditions" class="camera-conditions--container">
  <div class="camera-conditions--container-list show-desktop">
    <div data-jcs-element="camera__condition__glare" class="camera-conditions--container-list-item camera-condition--glare">
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.65385 0C6.84323 0 7.01636 0.107001 7.10106 0.276393L13.2549 12.5841C13.3324 12.7391 13.3241 12.9231 13.233 13.0706C13.1419 13.218 12.981 13.3077 12.8077 13.3077H0.500001C0.326712 13.3077 0.165778 13.218 0.0746751 13.0706C-0.0164282 12.9231 -0.0247102 12.7391 0.0527869 12.5841L6.20663 0.276393C6.29133 0.107001 6.46446 0 6.65385 0ZM11.9987 12.3077L6.65385 1.61803L1.30902 12.3077H11.9987ZM6.65403 4.92308C6.93018 4.92308 7.15403 5.14693 7.15403 5.42308V7.88461C7.15403 8.16076 6.93018 8.38461 6.65403 8.38461C6.37789 8.38461 6.15403 8.16076 6.15403 7.88461V5.42308C6.15403 5.14693 6.37789 4.92308 6.65403 4.92308ZM6.65381 10.9615C6.99368 10.9615 7.26919 10.686 7.26919 10.3462C7.26919 10.0063 6.99368 9.73077 6.65381 9.73077C6.31394 9.73077 6.03842 10.0063 6.03842 10.3462C6.03842 10.686 6.31394 10.9615 6.65381 10.9615Z" fill="#F88618"/>
      </svg>
      <span>
        {{CAMERA_CONDITION_GLARE}}
      </span>
    </div>
    <div data-jcs-element="camera__condition__blur" class="camera-conditions--container-list-item camera-condition--blur">
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.65385 0C6.84323 0 7.01636 0.107001 7.10106 0.276393L13.2549 12.5841C13.3324 12.7391 13.3241 12.9231 13.233 13.0706C13.1419 13.218 12.981 13.3077 12.8077 13.3077H0.500001C0.326712 13.3077 0.165778 13.218 0.0746751 13.0706C-0.0164282 12.9231 -0.0247102 12.7391 0.0527869 12.5841L6.20663 0.276393C6.29133 0.107001 6.46446 0 6.65385 0ZM11.9987 12.3077L6.65385 1.61803L1.30902 12.3077H11.9987ZM6.65403 4.92308C6.93018 4.92308 7.15403 5.14693 7.15403 5.42308V7.88461C7.15403 8.16076 6.93018 8.38461 6.65403 8.38461C6.37789 8.38461 6.15403 8.16076 6.15403 7.88461V5.42308C6.15403 5.14693 6.37789 4.92308 6.65403 4.92308ZM6.65381 10.9615C6.99368 10.9615 7.26919 10.686 7.26919 10.3462C7.26919 10.0063 6.99368 9.73077 6.65381 9.73077C6.31394 9.73077 6.03842 10.0063 6.03842 10.3462C6.03842 10.686 6.31394 10.9615 6.65381 10.9615Z" fill="#F88618"/>
      </svg>
      <span>
        {{CAMERA_CONDITION_BLUR}}
      </span>
    </div>
    <div data-jcs-element="camera__condition__low__resolution" class="camera-conditions--container-list-item camera-condition--low-resolution">
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.65385 0C6.84323 0 7.01636 0.107001 7.10106 0.276393L13.2549 12.5841C13.3324 12.7391 13.3241 12.9231 13.233 13.0706C13.1419 13.218 12.981 13.3077 12.8077 13.3077H0.500001C0.326712 13.3077 0.165778 13.218 0.0746751 13.0706C-0.0164282 12.9231 -0.0247102 12.7391 0.0527869 12.5841L6.20663 0.276393C6.29133 0.107001 6.46446 0 6.65385 0ZM11.9987 12.3077L6.65385 1.61803L1.30902 12.3077H11.9987ZM6.65403 4.92308C6.93018 4.92308 7.15403 5.14693 7.15403 5.42308V7.88461C7.15403 8.16076 6.93018 8.38461 6.65403 8.38461C6.37789 8.38461 6.15403 8.16076 6.15403 7.88461V5.42308C6.15403 5.14693 6.37789 4.92308 6.65403 4.92308ZM6.65381 10.9615C6.99368 10.9615 7.26919 10.686 7.26919 10.3462C7.26919 10.0063 6.99368 9.73077 6.65381 9.73077C6.31394 9.73077 6.03842 10.0063 6.03842 10.3462C6.03842 10.686 6.31394 10.9615 6.65381 10.9615Z" fill="#F88618"/>
      </svg>
      <span>
        {{CAMERA_CONDITION_LOW_RESOLUTION}}
      </span>
    </div>
    <div data-jcs-element="camera__condition__alignment" class="camera-conditions--container-list-item camera-condition--alignment">
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.65385 0C6.84323 0 7.01636 0.107001 7.10106 0.276393L13.2549 12.5841C13.3324 12.7391 13.3241 12.9231 13.233 13.0706C13.1419 13.218 12.981 13.3077 12.8077 13.3077H0.500001C0.326712 13.3077 0.165778 13.218 0.0746751 13.0706C-0.0164282 12.9231 -0.0247102 12.7391 0.0527869 12.5841L6.20663 0.276393C6.29133 0.107001 6.46446 0 6.65385 0ZM11.9987 12.3077L6.65385 1.61803L1.30902 12.3077H11.9987ZM6.65403 4.92308C6.93018 4.92308 7.15403 5.14693 7.15403 5.42308V7.88461C7.15403 8.16076 6.93018 8.38461 6.65403 8.38461C6.37789 8.38461 6.15403 8.16076 6.15403 7.88461V5.42308C6.15403 5.14693 6.37789 4.92308 6.65403 4.92308ZM6.65381 10.9615C6.99368 10.9615 7.26919 10.686 7.26919 10.3462C7.26919 10.0063 6.99368 9.73077 6.65381 9.73077C6.31394 9.73077 6.03842 10.0063 6.03842 10.3462C6.03842 10.686 6.31394 10.9615 6.65381 10.9615Z" fill="#F88618"/>
      </svg>
      <span>
        {{CAMERA_CONDITION_ALIGNMENT}}
      </span>
    </div>
  </div>
  <div class="camera-conditions--container-detail" data-jcs-element="camera__condition__detail">
    <div class="camera-conditions--container-detail-animation" data-jcs-element="camera__condition__detail__animation">
    </div>
    <div class="camera-conditions--container-detail-description">
      <div class="camera-conditions--container-detail-description-title">
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M11 0C11.3788 0 11.725 0.214002 11.8944 0.552786L21.8944 20.5528C22.0494 20.8628 22.0329 21.2309 21.8507 21.5257C21.6684 21.8205 21.3466 22 21 22H1C0.653423 22 0.331557 21.8205 0.14935 21.5257C-0.0328564 21.2309 -0.0494204 20.8628 0.105574 20.5528L10.1056 0.552786C10.275 0.214002 10.6212 0 11 0ZM19.382 20L11 3.23607L2.61804 20H19.382ZM11 8C11.5523 8 12 8.44771 12 9V13C12 13.5523 11.5523 14 11 14C10.4477 14 10 13.5523 10 13V9C10 8.44771 10.4477 8 11 8ZM11 18C11.5523 18 12 17.5523 12 17C12 16.4477 11.5523 16 11 16C10.4477 16 10 16.4477 10 17C10 17.5523 10.4477 18 11 18Z" fill="#F88618"/>
        </svg>
        <span class="camera-conditions--container-detail-description-title-text" data-jcs-element="camera__condition__detail__description__title">
        </span>
      </div>
      <div class="camera-conditions--container-detail-description-hint" data-jcs-element="camera__condition__detail__description__hint">
      </div>
    </div>
  </div>
</div	>
<div>

</div>
<form class="button-camera-container button-container no-style" data-jcs-element="camera__capture__hint">
<p class="camera-capture--caption">
  {{CAMERA_CAPTURE_CAPTION}}
</p>
</form>
<div class="help-inner-container" data-jcs-element="capture__help__container">
<h2>{{HELP_MODAL_AUTOCAPTURE_TITLE}}</h2>
<p>{{HELP_MODAL_AUTOCAPTURE_SUBTITLE}}</p>
<b>{{HELP_MODAL_AUTOCAPTURE_TIPS}}</b>
<div class="help-images-container">
  <div class="help-image-inner-container">
    <div class="help-image" data-jcs-element="modal__glare__animation__container"></div>
    <div class="help-text">
      <b>{{HELP_MODAL_AUTOCAPTURE_GLARE_TITLE}}</b>
      <p>{{HELP_MODAL_AUTOCAPTURE_GLARE_SUBTITLE}}</p>
    </div>
  </div>
  <div class="help-image-inner-container">
    <div class="help-image" data-jcs-element="modal__low__res__animation__container"></div>
    <div class="help-text">
      <b>{{HELP_MODAL_AUTOCAPTURE_FAR_TITLE}}</b>
      <p>{{HELP_MODAL_AUTOCAPTURE_FAR_SUBTITLE}}</p>
    </div>
  </div>
  <div class="help-image-inner-container">
    <div class="help-image" data-jcs-element="modal__blur__animation__container"></div>
    <div class="help-text">
      <b>{{HELP_MODAL_AUTOCAPTURE_BLUR_TITLE}}</b>
      <p>{{HELP_MODAL_AUTOCAPTURE_BLUR_SUBTITLE}}</p>
    </div>
  </div>
</div>
<div class="modal-footer modal-bottom modal-actions-container">
  <p data-jcs-element="capture__modal__manual__capture__text">{{HELP_MODAL_AUTOCAPTURE_MANUAL_CAPTURE}}</p>
  <div class="actions-container">
    <div class="help-button-container" data-jcs-element="capture__modal__camera__manual__capture">
      <label class="control control--switch manual--mode--switch" aria-label="switch">
        <input type="checkbox" data-jcs-element="capture__modal__camera__manual__capture__check" />
        <div class="control__switch control__switch__blue">
          <div class="icon ico-checkmark-16 control__switchIcon text-black">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon ico-checkmark-16 control__switchIcon text-black"><path d="M13 4L6 12L3 9" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
          </div>
        </div>
      </label>
      <p class="action-caption">{{HELP_MODAL_AUTOCAPTURE_TURN_MANUAL_CAPTURE}}</p>
    </div>
    <div class="spacer">
    </div>
    <div class="help-button-container" data-jcs-element="smart__capture__modal__close__help">
      <svg width="24" height="24" class="help-button-modal-close" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="11" stroke-width="2" stroke-linecap="round"/>
        <path d="M16 16L8 8M8 16L16 8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <p class="action-caption">{{REQUIRED_ACTION_Close}}</p>
    </div>
  </div>
</div>
</div>
<div class="notification notification-blue" data-jcs-element="attempt__count__container">
  <div class="notification-container">
    <div class="system-not-able">
      <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="17" cy="17" r="16.2273" stroke="#FAB313" stroke-width="1.54545"/>
        <path d="M17.4281 20.7078H16.0019L15.3091 6.32328H18.1208L17.4281 20.7078ZM15.0646 24.742C15.0646 23.5104 15.608 22.8947 16.6946 22.8947C17.2198 22.8947 17.6228 23.0531 17.9035 23.3701C18.1933 23.687 18.3382 24.1443 18.3382 24.742C18.3382 25.3215 18.1933 25.7743 17.9035 26.1003C17.6137 26.4172 17.2108 26.5757 16.6946 26.5757C16.2237 26.5757 15.8343 26.4353 15.5265 26.1546C15.2186 25.8648 15.0646 25.3939 15.0646 24.742Z" fill="#FAB313"/>
      </svg>        
      <p>{{SYSTEM_NOT_ABLE}}</p>
    </div>
    <p class="notification-counter">{{ATTEMPTS_REMAINING}} <span
        data-jcs-element="attempt__counter"></span>{{PREVIEW_ATTEMPT_NUMBER_END}}</p>
  </div>
  <button class="notification-photo-help button">
        <span>
        <p>?</p>
        {{HOW_TO_TAKE_PHOTO_CORRECTLY}}
        </span>
      </button>
  <button class="help-button-wrapper button">
  <span>{{TRY_AGAIN}}</span>
  </button>
</div>
</div>
<div data-jcs-element="view__status">
<p data-jcs-element="view__status__message"></p>
</div>
<div class="actions-container">
<div data-jcs-element="camera__manual__capture" class="camera__manual__capture">
<label class="control control--switch manual--mode--switch" aria-label="switch">
  <input type="checkbox" data-jcs-element="camera__manual__capture__check" />
  <div class="control__switch">
    <div class="icon ico-checkmark-16 control__switchIcon text-black">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon ico-checkmark-16 control__switchIcon text-black"><path d="M13 4L6 12L3 9" stroke="rgb(0, 13, 26)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
    </div>
  </div>
</label>
<p class="action-caption">{{HELP_MODAL_AUTOCAPTURE_TURN_MANUAL_CAPTURE}}</p>
</div>
<div class="spacer">
</div>
<div>
<div class="help-button-container" data-jcs-element="smart__capture__close__help">
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="11" stroke="white" stroke-width="2" stroke-linecap="round"/>
    <path d="M16 16L8 8M8 16L16 8" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
  <p class="action-caption">{{REQUIRED_ACTION_Close}}</p>
</div>
<div class="help-button-container">
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="question-mark-svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12ZM12 7C11.0445 7 10 7.68564 10 9C10 9.55228 9.55229 10 9 10C8.44771 10 8 9.55228 8 9C8 6.31436 10.227 5 12 5C14.2091 5 16 6.79086 16 9C16 10.8638 14.7252 12.4299 13 12.874V12.8746V12.8787V12.8827V12.8868V12.8909V12.895V12.8991V12.9031V12.9072V12.9113V12.9153V12.9194V12.9234V12.9275V12.9315V12.9355V12.9396V12.9436V12.9476V12.9517V12.9557V12.9597V12.9637V12.9677V12.9717V12.9757V12.9796V12.9836V12.9876V12.9915V12.9955V12.9995V13.0034V13.0073V13.0113V13.0152V13.0191V13.023V13.0269V13.0308V13.0347V13.0386V13.0425V13.0463V13.0502V13.0541V13.0579V13.0617V13.0656V13.0694V13.0732V13.077V13.0808V13.0846V13.0884V13.0922V13.0959V13.0997V13.1034V13.1071V13.1109V13.1146V13.1183V13.122V13.1257V13.1294V13.133V13.1367V13.1403V13.144V13.1476V13.1512V13.1548V13.1584V13.162V13.1656V13.1691V13.1727V13.1762V13.1797V13.1832V13.1868V13.1902V13.1937V13.1972V13.2007V13.2041V13.2075V13.211V13.2144V13.2178V13.2211V13.2245V13.2279V13.2312V13.2345V13.2379V13.2412V13.2445V13.2477V13.251V13.2542V13.2575V13.2607V13.2639V13.2671V13.2703V13.2735V13.2766V13.2797V13.2829V13.286V13.2891V13.2921V13.2952V13.2983V13.3013V13.3043V13.3073V13.3103V13.3133V13.3162V13.3191V13.3221V13.325V13.3279V13.3307V13.3336V13.3364V13.3392V13.342V13.3448V13.3476V13.3504V13.3531V13.3558V13.3585V13.3612V13.3639V13.3665V13.3691V13.3718V13.3744V13.3769V13.3795V13.382V13.3845V13.387V13.3895V13.392V13.3944V13.3969V13.3993V13.4017V13.404V13.4064V13.4087V13.411V13.4133V13.4156V13.4178V13.42V13.4223V13.4244V13.4266V13.4288V13.4309V13.433V13.4351V13.4371V13.4392V13.4412V13.4432V13.4452V13.4471V13.4491V13.451V13.4529V13.4547V13.4566V13.4584V13.4602V13.462V13.4637V13.4655V13.4672V13.4689V13.4705V13.4722V13.4738V13.4754V13.477V13.4785V13.48V13.4815V13.483V13.4845V13.4859V13.4873V13.4887V13.49V13.4914V13.4927V13.494V13.4952V13.4965V13.4977V13.4988V13.5C13 14.0523 12.5523 14.5 12 14.5C11.4477 14.5 11 14.0523 11 13.5V13.4988V13.4977V13.4965V13.4952V13.494V13.4927V13.4914V13.49V13.4887V13.4873V13.4859V13.4845V13.483V13.4815V13.48V13.4785V13.477V13.4754V13.4738V13.4722V13.4705V13.4689V13.4672V13.4655V13.4637V13.462V13.4602V13.4584V13.4566V13.4547V13.4529V13.451V13.4491V13.4471V13.4452V13.4432V13.4412V13.4392V13.4371V13.4351V13.433V13.4309V13.4288V13.4266V13.4244V13.4223V13.42V13.4178V13.4156V13.4133V13.411V13.4087V13.4064V13.404V13.4017V13.3993V13.3969V13.3944V13.392V13.3895V13.387V13.3845V13.382V13.3795V13.3769V13.3744V13.3718V13.3691V13.3665V13.3639V13.3612V13.3585V13.3558V13.3531V13.3504V13.3476V13.3448V13.342V13.3392V13.3364V13.3336V13.3307V13.3279V13.325V13.3221V13.3191V13.3162V13.3133V13.3103V13.3073V13.3043V13.3013V13.2983V13.2952V13.2921V13.2891V13.286V13.2829V13.2797V13.2766V13.2735V13.2703V13.2671V13.2639V13.2607V13.2575V13.2542V13.251V13.2477V13.2445V13.2412V13.2379V13.2345V13.2312V13.2279V13.2245V13.2211V13.2178V13.2144V13.211V13.2075V13.2041V13.2007V13.1972V13.1937V13.1902V13.1868V13.1832V13.1797V13.1762V13.1727V13.1691V13.1656V13.162V13.1584V13.1548V13.1512V13.1476V13.144V13.1403V13.1367V13.133V13.1294V13.1257V13.122V13.1183V13.1146V13.1109V13.1071V13.1034V13.0997V13.0959V13.0922V13.0884V13.0846V13.0808V13.077V13.0732V13.0694V13.0656V13.0617V13.0579V13.0541V13.0502V13.0463V13.0425V13.0386V13.0347V13.0308V13.0269V13.023V13.0191V13.0152V13.0113V13.0073V13.0034V12.9995V12.9955V12.9915V12.9876V12.9836V12.9796V12.9757V12.9717V12.9677V12.9637V12.9597V12.9557V12.9517V12.9476V12.9436V12.9396V12.9355V12.9315V12.9275V12.9234V12.9194V12.9153V12.9113V12.9072V12.9031V12.8991V12.895V12.8909V12.8868V12.8827V12.8787V12.8746V12.8705V12.8664V12.8623V12.8582V12.8541V12.85V12.8459V12.8418V12.8376V12.8335V12.8294V12.8253V12.8212V12.8171V12.8129V12.8088V12.8047V12.8006V12.7964V12.7923V12.7882V12.784V12.7799V12.7758V12.7716V12.7675V12.7634V12.7592V12.7551V12.751V12.7469V12.7427V12.7386V12.7345V12.7303V12.7262V12.7221V12.718V12.7138V12.7097V12.7056V12.7015V12.6973V12.6932V12.6891V12.685V12.6809V12.6768V12.6727V12.6686V12.6645V12.6604V12.6563V12.6522V12.6481V12.644V12.6399V12.6358V12.6317V12.6277V12.6236V12.6195V12.6155V12.6114V12.6073V12.6033V12.5992V12.5952V12.5912V12.5871V12.5831V12.5791V12.575V12.571V12.567V12.563V12.559V12.555V12.551V12.547V12.5431V12.5391V12.5351V12.5312V12.5272V12.5233V12.5193V12.5154V12.5114V12.5075V12.5036V12.4997V12.4958V12.4919V12.488V12.4841V12.4803V12.4764V12.4725V12.4687V12.4648V12.461V12.4572V12.4534V12.4496V12.4458V12.442V12.4382V12.4344V12.4306V12.4269V12.4231V12.4194V12.4157V12.4119V12.4082V12.4045V12.4008V12.3971V12.3935V12.3898V12.3862V12.3825V12.3789V12.3753V12.3716V12.368V12.3645V12.3609V12.3573V12.3538V12.3502V12.3467V12.3432V12.3396V12.3361V12.3327V12.3292V12.3257V12.3223V12.3188V12.3154V12.312V12.3086V12.3052V12.3018V12.2984V12.2951V12.2917V12.2884V12.2851V12.2818V12.2785V12.2753V12.272V12.2687V12.2655V12.2623V12.2591V12.2559V12.2527V12.2496V12.2464V12.2433V12.2402V12.2371V12.234V12.2309V12.2279V12.2248V12.2218V12.2188V12.2158V12.2128V12.2099V12.2069V12.204V12.2011V12.1982V12.1953V12.1924V12.1896V12.1867V12.1839V12.1811V12.1784V12.1756V12.1728V12.1701V12.1674V12.1647V12.162V12.1594V12.1567V12.1541V12.1515V12.1489V12.1463V12.1438V12.1413V12.1388V12.1363V12.1338V12.1313V12.1289V12.1265V12.1241V12.1217V12.1193V12.117V12.1147V12.1124V12.1101V12.1078V12.1056V12.1034V12.1012V12.099V12.0968V12.0947V12.0926V12.0905V12.0884V12.0864V12.0843V12.0823V12.0803V12.0783V12.0764V12.0745V12.0726V12.0707V12.0688V12.067V12.0652V12.0634V12.0616V12.0599V12.0581V12.0564V12.0548V12.0531V12.0515V12.0499V12.0483V12.0467V12.0452V12.0437V12.0422V12.0407V12.0393V12.0378V12.0365V12.0351V12.0337V12.0324V12.0311V12.0298V12.0286V12.0274V12.0262V12.025V12.0239V12.0227V12.0216V12.0206V12.0195V12.0185V12.0175V12.0166V12.0156V12.0147V12.0138V12.013V12.0121V12.0113V12.0105V12.0098V12.0091V12.0084V12.0077V12.007V12.0064V12.0058V12.0053V12.0047V12.0042V12.0037V12.0033V12.0029V12.0025V12.0021V12.0018V12.0015V12.0012V12.0009V12.0007V12.0005V12.0004V12.0002V12.0001V12.0001V12L12 12H11C11 11.4477 11.4477 11 12 11C13.1046 11 14 10.1046 14 9C14 7.89543 13.1046 7 12 7ZM12 18C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18Z" fill="white"/>
  </svg>
  </div>
  </div>
  </div>
  </div>
  <button class="action-caption show-help-button">{{HELP_MODAL_NEED_HELP}}</button>`;
}
export function camera() {
  return `<div class="dark-inner-provider-container">
<div>
<form class="camera-options--container no-style">
<select data-jcs-element="camera__select" class="camera-choices camera-choices-half-s camera-choices-full-xs control control--select"></select>
</form>
<div data-jcs-element="info__journey__action__container" class="camera-capture--caption" style="display: none">
  <p data-jcs-element="info__journey__action__text"></p>
</div>
<div class="help-container">
<div class="camera-viewfinder--container">
  <canvas data-jcs-element="camera__viewfinder" class="camera-viewfinder"></canvas>
  <div data-jcs-element="overlay_viewfinder" class="camera-viewfinder--overlay--transparent">
    <div class="loading-animation-container" data-jcs-element="loading-animation" style="display:none">
    </div>
    <div class="gbg-loader camera">
      <svg class="circular" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="3" stroke-miterlimit="10" />
      </svg>
      <p>{{PICTURE_VERIFYING}}</p>
    </div>
  </div>
</div>
<div data-jcs-element="info__journey__action__selfie__container" class="camera-capture--caption" style="display: none">
  {{CAMERA_CAPTURE_SELFIE_CAPTION}}
</div>
<div data-jcs-element="info__journey__action__address__container" class="camera-capture--caption" style="display: none">
  {{CAMERA_CAPTURE_ADDRESS_CAPTION}}
</div>
<div data-jcs-element="info__journey__action__covid__container" class="camera-capture--caption" style="display: none">
  {{CAMERA_CAPTURE_COVID_CAPTION}}
</div>
<div class="help-inner-container" data-jcs-element="capture__help__container" style="display:none">
  <h2>{{HELP_MODAL_AUTOCAPTURE_TITLE}}</h2>
  <p>{{HELP_MODAL_AUTOCAPTURE_SUBTITLE}}</p>
  <b>{{HELP_MODAL_AUTOCAPTURE_TIPS}}</b>
  <div class="help-images-container">
    <div class="help-image-inner-container">
      <div class="help-image" data-jcs-element="capture__modal__glare__animation__container"></div>
      <div class="help-text">
        <b>{{HELP_MODAL_AUTOCAPTURE_GLARE_TITLE}}</b>
        <p>{{HELP_MODAL_AUTOCAPTURE_GLARE_SUBTITLE}}</p>
      </div>
    </div>
    <div class="help-image-inner-container">
      <div class="help-image" data-jcs-element="capture__modal__low__res__animation__container"></div>
      <div class="help-text">
        <b>{{HELP_MODAL_AUTOCAPTURE_FAR_TITLE}}</b>
        <p>{{HELP_MODAL_AUTOCAPTURE_FAR_SUBTITLE}}</p>
      </div>
    </div>
    <div class="help-image-inner-container">
      <div class="help-image" data-jcs-element="capture__modal__blur__animation__container"></div>
      <div class="help-text">
        <b>{{HELP_MODAL_AUTOCAPTURE_BLUR_TITLE}}</b>
        <p>{{HELP_MODAL_AUTOCAPTURE_BLUR_SUBTITLE}}</p>
      </div>
    </div>
  </div>
  <div class="modal-footer modal-bottom modal-actions-container">
    <p data-jcs-element="capture__modal__manual__capture__text">{{HELP_MODAL_AUTOCAPTURE_MANUAL_CAPTURE}}</p>
    <div class="actions-container">
      <div data-jcs-element="capture__modal__camera__manual__capture">
        <label class="control control--switch manual--mode--switch" aria-label="switch">
          <input type="checkbox" data-jcs-element="capture__modal__camera__manual__capture__check" checked />
          <div class="control__switch control__switch__blue">
            <div class="icon ico-checkmark-16 control__switchIcon text-black">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon ico-checkmark-16 control__switchIcon text-black"><path d="M13 4L6 12L3 9" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
            </div>
          </div>
        </label>
        <p class="action-caption">{{HELP_MODAL_AUTOCAPTURE_TURN_MANUAL_CAPTURE}}</p>
      </div>
      <div class="spacer"></div>
      <div class="help-button-container" data-jcs-element="capture__modal__close__help">
        <svg width="24" height="24" class="help-button-modal-close" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="11" stroke-width="2" stroke-linecap="round"/>
          <path d="M16 16L8 8M8 16L16 8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <p class="action-caption">{{REQUIRED_ACTION_Close}}</p>
      </div>
    </div>
  </div>
</div>
<div class="help-inner-container" data-jcs-element="capture__selfie__help__container" style="display:none">
  <h2>{{HELP_MODAL_SELFIE_TITLE}}</h2>
  <p>{{HELP_MODAL_SELFIE_SUBTITLE}}</p>
  <div class="show-mobile">
    <div class="help-info-inner-container" data-jcs-element="preview__info__container__fm">
      <span class="preview-info-title">{{PREVIEW_INFO_TITLE_ID}}</span>
      <div class="id-example-container">
        <div class="id-example-container-row">
          <div class="id-example id-example-good">
            <img class="sample-image sample-image-success" src="assets/images/selfie-good.svg" />
            <div class="separating-rectangle separating-rectangle-success"></div>
            <div class="preview-label preview-label-success">
              <img class="preview-label-icon" src="assets/images/green-check-icon.svg" />
              <span>{{PREVIEW_INFO_GOOD}}</span>
            </div>
            <span class="preview-info-example-text ">{{PREVIEW_INFO_GOOD_EXAMPLE_FACEMATCH}}</span>
          </div>
          <div class="id-example id-example-angle-check">
            <img class="sample-image sample-image-error" src="assets/images/selfie-partial.svg" />
            <div class="separating-rectangle separating-rectangle-error"></div>
            <div class="preview-label preview-label-error">
              <img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
              <span>{{PREVIEW_INFO_BAD}}</span>
            </div>
            <span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_ANGLE_FACEMATCH}}</span>
          </div>
        </div>
        <div class="id-example-container-row">
          <div class="id-example id-example-cover-check">
            <img class="sample-image sample-image-error" src="assets/images/selfie-glasses.svg" />
            <div class="separating-rectangle separating-rectangle-error"></div>
            <div class="preview-label preview-label-error">
              <img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
              <span>{{PREVIEW_INFO_BAD}}</span>
            </div>
            <span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_COVER_FACEMATCH}}</span>
          </div>
          <div class="id-example id-example-blur-check">
            <img class="sample-image sample-image-error" src="assets/images/selfie-blurred.svg" />
            <div class="separating-rectangle separating-rectangle-error"></div>
            <div class="preview-label preview-label-error">
              <img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
              <span>{{PREVIEW_INFO_BAD}}</span>
            </div>
            <span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_BLUR_FACEMATCH}}</span>
          </div>
        </div>
      </div>
      <div class="modal-close-button close-preview-info-button" data-jcs-element="capture__selfie__modal__close__help">
        <svg width="24" height="24" class="help-button-modal-close" viewBox="0 0 24 24" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="11" stroke-width="2" stroke-linecap="round" />
          <path d="M16 16L8 8M8 16L16 8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <p class="action-caption">{{REQUIRED_ACTION_Close}}</p>
      </div>
    </div>
  </div>
  <div class="show-desktop preview-info-container">
    <div class="preview-info-title">
      <img class="preview-info-icon" src="assets/images/info-icon.svg">
      <span class="preview-info-main-text">{{PREVIEW_INFO_TITLE_ID}}</span>
    </div>
    <ul class="id-example-container">
      <li class="id-example id-example-good">
        <img class="sample-image sample-image-success" src="assets/images/selfie-good.svg">
        <div class="separating-rectangle separating-rectangle-success"></div>
        <div class="preview-label preview-label-success">
          <img class="preview-label-icon" src="assets/images/green-check-icon.svg">
          <span>{{PREVIEW_INFO_GOOD}}</span>
        </div>
        <span class="preview-info-example-text ">{{PREVIEW_INFO_GOOD_EXAMPLE_FACEMATCH}}</span>
      </li>
      <li class="id-example id-example-angle-check">
        <img class="sample-image sample-image-error" src="assets/images/selfie-partial.svg">
        <div class="separating-rectangle separating-rectangle-error"></div>
        <div class="preview-label preview-label-error">
          <img class="preview-label-icon" src="assets/images/red-x-icon.svg">
          <span>{{PREVIEW_INFO_BAD}}</span>
        </div>
        <span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_ANGLE_FACEMATCH}}</span>
      </li>
      <li class="id-example id-example-cover-check">
        <img class="sample-image sample-image-error" src="assets/images/selfie-glasses.svg">
        <div class="separating-rectangle separating-rectangle-error"></div>
        <div class="preview-label preview-label-error">
          <img class="preview-label-icon" src="assets/images/red-x-icon.svg">
          <span>{{PREVIEW_INFO_BAD}}</span>
        </div>
        <span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_COVER_FACEMATCH}}</span>
      </li>
      <li class="id-example id-example-blur-check">
        <img class="sample-image sample-image-error" src="assets/images/selfie-blurred.svg">
        <div class="separating-rectangle separating-rectangle-error"></div>
        <div class="preview-label preview-label-error">
          <img class="preview-label-icon" src="assets/images/red-x-icon.svg">
          <span>{{PREVIEW_INFO_BAD}}</span>
        </div>
        <span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_BLUR_FACEMATCH}}</span>
      </li>
    </ul>
  </div>
</div>
<div class="help-inner-container" data-jcs-element="capture__covid__help__container" style="display:none">
  <h2>{{HELP_MODAL_COVID_TITLE}}</h2>
  <p>{{HELP_MODAL_COVID_SUBTITLE}}</p>
  <b>{{HELP_MODAL_COVID_TIPS}}</b>
  <div class="help-images-container">
    <div class="help-image-inner-container">
      <div class="help-image" data-jcs-element="capture__covid__modal__glare__animation__container"></div>
      <div class="help-text">
        <b>{{HELP_MODAL_COVID_GLARE_TITLE}}</b>
        <p>{{HELP_MODAL_COVID_GLARE_SUBTITLE}}</p>
      </div>
    </div>
    <div class="help-image-inner-container">
      <div class="help-image" data-jcs-element="capture__covid__modal__low__res__animation__container"></div>
      <div class="help-text">
        <b>{{HELP_MODAL_COVID_FAR_TITLE}}</b>
        <p>{{HELP_MODAL_COVID_FAR_SUBTITLE}}</p>
      </div>
    </div>
    <div class="help-image-inner-container">
      <div class="help-image" data-jcs-element="capture__covid__modal__blur__animation__container"></div>
      <div class="help-text">
        <b>{{HELP_MODAL_COVID_BLUR_TITLE}}</b>
        <p>{{HELP_MODAL_COVID_BLUR_SUBTITLE}}</p>
      </div>
    </div>
  </div>
  <div class="modal-footer modal-bottom modal-actions-container">
    <div class="actions-container">
      <div>

      </div>
      <div class="spacer"></div>
      <div class="help-button-container" data-jcs-element="capture__covid__modal__close__help">
        <svg width="24" height="24" class="help-button-modal-close" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="11" stroke-width="2" stroke-linecap="round"/>
          <path d="M16 16L8 8M8 16L16 8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <p class="action-caption">{{REQUIRED_ACTION_Close}}</p>
      </div>
    </div>
  </div>
</div>

</div>
<div class="help-inner-container" data-jcs-element="capture__covid__help__container" style="display:none">
  <h2>{{HELP_MODAL_COVID_TITLE}}</h2>
  <p>{{HELP_MODAL_COVID_SUBTITLE}}</p>
  <b>{{HELP_MODAL_COVID_TIPS}}</b>
  <div class="help-images-container">
    <div class="help-image-inner-container">
      <div class="help-image" data-jcs-element="capture__covid__modal__glare__animation__container"></div>
      <div class="help-text">
        <b>{{HELP_MODAL_COVID_GLARE_TITLE}}</b>
        <p>{{HELP_MODAL_COVID_GLARE_SUBTITLE}}</p>
      </div>
    </div>
    <div class="help-image-inner-container">
      <div class="help-image" data-jcs-element="capture__covid__modal__low__res__animation__container"></div>
      <div class="help-text">
        <b>{{HELP_MODAL_COVID_FAR_TITLE}}</b>
        <p>{{HELP_MODAL_COVID_FAR_SUBTITLE}}</p>
      </div>
    </div>
    <div class="help-image-inner-container">
      <div class="help-image" data-jcs-element="capture__covid__modal__blur__animation__container"></div>
      <div class="help-text">
        <b>{{HELP_MODAL_COVID_BLUR_TITLE}}</b>
        <p>{{HELP_MODAL_COVID_BLUR_SUBTITLE}}</p>
      </div>
    </div>
  </div>
  <div class="modal-footer modal-bottom modal-actions-container">
    <div class="actions-container">
      <div>

      </div>
      <div class="spacer"></div>
      <div class="help-button-container" data-jcs-element="capture__covid__modal__close__help">
        <svg width="24" height="24" class="help-button-modal-close" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="11" stroke-width="2" stroke-linecap="round"/>
          <path d="M16 16L8 8M8 16L16 8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <p class="action-caption">{{REQUIRED_ACTION_Close}}</p>
      </div>
    </div>
  </div>
</div>

<div class="notification notification-blue" data-jcs-element="attempt__count__container">
  <div class="notification-container">
    <div class="system-not-able">
      <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="17" cy="17" r="16.2273" stroke="#FAB313" stroke-width="1.54545"/>
        <path d="M17.4281 20.7078H16.0019L15.3091 6.32328H18.1208L17.4281 20.7078ZM15.0646 24.742C15.0646 23.5104 15.608 22.8947 16.6946 22.8947C17.2198 22.8947 17.6228 23.0531 17.9035 23.3701C18.1933 23.687 18.3382 24.1443 18.3382 24.742C18.3382 25.3215 18.1933 25.7743 17.9035 26.1003C17.6137 26.4172 17.2108 26.5757 16.6946 26.5757C16.2237 26.5757 15.8343 26.4353 15.5265 26.1546C15.2186 25.8648 15.0646 25.3939 15.0646 24.742Z" fill="#FAB313"/>
      </svg>   
      <p>{{SYSTEM_NOT_ABLE}}</p>
    </div>
    <p class="notification-counter">{{ATTEMPTS_REMAINING}} <span
        data-jcs-element="attempt__counter"></span>{{PREVIEW_ATTEMPT_NUMBER_END}}</p>
  </div>
  <button class="notification-photo-help button">
        <span>
        <p>?</p>
        {{HOW_TO_TAKE_PHOTO_CORRECTLY}}
        </span>
      </button>
  <button class="help-button-wrapper button">
    <span>{{TRY_AGAIN}}</span>
  </button>
</div>
</div>
<div class="manual-warning-container">
  <p class="manual-warning-text manual-warning-text--orange">{{HINTS_DISABLED_HEADER}}</p>
  <p class="manual-warning-text">{{HINTS_DISABLED_DESCRIPTION}}</p>
</div>
<div data-jcs-element="view__status">
<p data-jcs-element="view__status__message"></p>
</div>
<div class="actions-container">
<div data-jcs-element="camera__manual__capture" class="item camera__manual__capture">
  <div data-jcs-element="camera__manual__capture__inner" style="display: none;">
    <label class="control control--switch manual--mode--switch" aria-label="switch">
      <input type="checkbox" checked/>
      <div class="control__switch">
        <div class="icon ico-checkmark-16 control__switchIcon text-black">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon ico-checkmark-16 control__switchIcon text-black"><path d="M13 4L6 12L3 9" stroke="rgb(0, 13, 26)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
        </div>
      </div>
    </label>
    <p class="action-caption">{{HELP_MODAL_POA_TURN_MANUAL_CAPTURE}}</p>
  </div>
</div>
<form class="manual-capture-button-container item no-style">
  <div class="camera-capture--container">
    <input data-jcs-element="camera__capture" class="camera-capture--button" type="button" />
  </div>
</form>
<div class="item">
  <div class="help-button-container" data-jcs-element="capture__close__help">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="11" stroke="white" stroke-width="2" stroke-linecap="round"/>
      <path d="M16 16L8 8M8 16L16 8" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <p class="action-caption">{{REQUIRED_ACTION_Close}}</p>
  </div>
  <div class="help-button-container">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12ZM12 7C11.0445 7 10 7.68564 10 9C10 9.55228 9.55229 10 9 10C8.44771 10 8 9.55228 8 9C8 6.31436 10.227 5 12 5C14.2091 5 16 6.79086 16 9C16 10.8638 14.7252 12.4299 13 12.874V12.8746V12.8787V12.8827V12.8868V12.8909V12.895V12.8991V12.9031V12.9072V12.9113V12.9153V12.9194V12.9234V12.9275V12.9315V12.9355V12.9396V12.9436V12.9476V12.9517V12.9557V12.9597V12.9637V12.9677V12.9717V12.9757V12.9796V12.9836V12.9876V12.9915V12.9955V12.9995V13.0034V13.0073V13.0113V13.0152V13.0191V13.023V13.0269V13.0308V13.0347V13.0386V13.0425V13.0463V13.0502V13.0541V13.0579V13.0617V13.0656V13.0694V13.0732V13.077V13.0808V13.0846V13.0884V13.0922V13.0959V13.0997V13.1034V13.1071V13.1109V13.1146V13.1183V13.122V13.1257V13.1294V13.133V13.1367V13.1403V13.144V13.1476V13.1512V13.1548V13.1584V13.162V13.1656V13.1691V13.1727V13.1762V13.1797V13.1832V13.1868V13.1902V13.1937V13.1972V13.2007V13.2041V13.2075V13.211V13.2144V13.2178V13.2211V13.2245V13.2279V13.2312V13.2345V13.2379V13.2412V13.2445V13.2477V13.251V13.2542V13.2575V13.2607V13.2639V13.2671V13.2703V13.2735V13.2766V13.2797V13.2829V13.286V13.2891V13.2921V13.2952V13.2983V13.3013V13.3043V13.3073V13.3103V13.3133V13.3162V13.3191V13.3221V13.325V13.3279V13.3307V13.3336V13.3364V13.3392V13.342V13.3448V13.3476V13.3504V13.3531V13.3558V13.3585V13.3612V13.3639V13.3665V13.3691V13.3718V13.3744V13.3769V13.3795V13.382V13.3845V13.387V13.3895V13.392V13.3944V13.3969V13.3993V13.4017V13.404V13.4064V13.4087V13.411V13.4133V13.4156V13.4178V13.42V13.4223V13.4244V13.4266V13.4288V13.4309V13.433V13.4351V13.4371V13.4392V13.4412V13.4432V13.4452V13.4471V13.4491V13.451V13.4529V13.4547V13.4566V13.4584V13.4602V13.462V13.4637V13.4655V13.4672V13.4689V13.4705V13.4722V13.4738V13.4754V13.477V13.4785V13.48V13.4815V13.483V13.4845V13.4859V13.4873V13.4887V13.49V13.4914V13.4927V13.494V13.4952V13.4965V13.4977V13.4988V13.5C13 14.0523 12.5523 14.5 12 14.5C11.4477 14.5 11 14.0523 11 13.5V13.4988V13.4977V13.4965V13.4952V13.494V13.4927V13.4914V13.49V13.4887V13.4873V13.4859V13.4845V13.483V13.4815V13.48V13.4785V13.477V13.4754V13.4738V13.4722V13.4705V13.4689V13.4672V13.4655V13.4637V13.462V13.4602V13.4584V13.4566V13.4547V13.4529V13.451V13.4491V13.4471V13.4452V13.4432V13.4412V13.4392V13.4371V13.4351V13.433V13.4309V13.4288V13.4266V13.4244V13.4223V13.42V13.4178V13.4156V13.4133V13.411V13.4087V13.4064V13.404V13.4017V13.3993V13.3969V13.3944V13.392V13.3895V13.387V13.3845V13.382V13.3795V13.3769V13.3744V13.3718V13.3691V13.3665V13.3639V13.3612V13.3585V13.3558V13.3531V13.3504V13.3476V13.3448V13.342V13.3392V13.3364V13.3336V13.3307V13.3279V13.325V13.3221V13.3191V13.3162V13.3133V13.3103V13.3073V13.3043V13.3013V13.2983V13.2952V13.2921V13.2891V13.286V13.2829V13.2797V13.2766V13.2735V13.2703V13.2671V13.2639V13.2607V13.2575V13.2542V13.251V13.2477V13.2445V13.2412V13.2379V13.2345V13.2312V13.2279V13.2245V13.2211V13.2178V13.2144V13.211V13.2075V13.2041V13.2007V13.1972V13.1937V13.1902V13.1868V13.1832V13.1797V13.1762V13.1727V13.1691V13.1656V13.162V13.1584V13.1548V13.1512V13.1476V13.144V13.1403V13.1367V13.133V13.1294V13.1257V13.122V13.1183V13.1146V13.1109V13.1071V13.1034V13.0997V13.0959V13.0922V13.0884V13.0846V13.0808V13.077V13.0732V13.0694V13.0656V13.0617V13.0579V13.0541V13.0502V13.0463V13.0425V13.0386V13.0347V13.0308V13.0269V13.023V13.0191V13.0152V13.0113V13.0073V13.0034V12.9995V12.9955V12.9915V12.9876V12.9836V12.9796V12.9757V12.9717V12.9677V12.9637V12.9597V12.9557V12.9517V12.9476V12.9436V12.9396V12.9355V12.9315V12.9275V12.9234V12.9194V12.9153V12.9113V12.9072V12.9031V12.8991V12.895V12.8909V12.8868V12.8827V12.8787V12.8746V12.8705V12.8664V12.8623V12.8582V12.8541V12.85V12.8459V12.8418V12.8376V12.8335V12.8294V12.8253V12.8212V12.8171V12.8129V12.8088V12.8047V12.8006V12.7964V12.7923V12.7882V12.784V12.7799V12.7758V12.7716V12.7675V12.7634V12.7592V12.7551V12.751V12.7469V12.7427V12.7386V12.7345V12.7303V12.7262V12.7221V12.718V12.7138V12.7097V12.7056V12.7015V12.6973V12.6932V12.6891V12.685V12.6809V12.6768V12.6727V12.6686V12.6645V12.6604V12.6563V12.6522V12.6481V12.644V12.6399V12.6358V12.6317V12.6277V12.6236V12.6195V12.6155V12.6114V12.6073V12.6033V12.5992V12.5952V12.5912V12.5871V12.5831V12.5791V12.575V12.571V12.567V12.563V12.559V12.555V12.551V12.547V12.5431V12.5391V12.5351V12.5312V12.5272V12.5233V12.5193V12.5154V12.5114V12.5075V12.5036V12.4997V12.4958V12.4919V12.488V12.4841V12.4803V12.4764V12.4725V12.4687V12.4648V12.461V12.4572V12.4534V12.4496V12.4458V12.442V12.4382V12.4344V12.4306V12.4269V12.4231V12.4194V12.4157V12.4119V12.4082V12.4045V12.4008V12.3971V12.3935V12.3898V12.3862V12.3825V12.3789V12.3753V12.3716V12.368V12.3645V12.3609V12.3573V12.3538V12.3502V12.3467V12.3432V12.3396V12.3361V12.3327V12.3292V12.3257V12.3223V12.3188V12.3154V12.312V12.3086V12.3052V12.3018V12.2984V12.2951V12.2917V12.2884V12.2851V12.2818V12.2785V12.2753V12.272V12.2687V12.2655V12.2623V12.2591V12.2559V12.2527V12.2496V12.2464V12.2433V12.2402V12.2371V12.234V12.2309V12.2279V12.2248V12.2218V12.2188V12.2158V12.2128V12.2099V12.2069V12.204V12.2011V12.1982V12.1953V12.1924V12.1896V12.1867V12.1839V12.1811V12.1784V12.1756V12.1728V12.1701V12.1674V12.1647V12.162V12.1594V12.1567V12.1541V12.1515V12.1489V12.1463V12.1438V12.1413V12.1388V12.1363V12.1338V12.1313V12.1289V12.1265V12.1241V12.1217V12.1193V12.117V12.1147V12.1124V12.1101V12.1078V12.1056V12.1034V12.1012V12.099V12.0968V12.0947V12.0926V12.0905V12.0884V12.0864V12.0843V12.0823V12.0803V12.0783V12.0764V12.0745V12.0726V12.0707V12.0688V12.067V12.0652V12.0634V12.0616V12.0599V12.0581V12.0564V12.0548V12.0531V12.0515V12.0499V12.0483V12.0467V12.0452V12.0437V12.0422V12.0407V12.0393V12.0378V12.0365V12.0351V12.0337V12.0324V12.0311V12.0298V12.0286V12.0274V12.0262V12.025V12.0239V12.0227V12.0216V12.0206V12.0195V12.0185V12.0175V12.0166V12.0156V12.0147V12.0138V12.013V12.0121V12.0113V12.0105V12.0098V12.0091V12.0084V12.0077V12.007V12.0064V12.0058V12.0053V12.0047V12.0042V12.0037V12.0033V12.0029V12.0025V12.0021V12.0018V12.0015V12.0012V12.0009V12.0007V12.0005V12.0004V12.0002V12.0001V12.0001V12L12 12H11C11 11.4477 11.4477 11 12 11C13.1046 11 14 10.1046 14 9C14 7.89543 13.1046 7 12 7ZM12 18C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18Z" fill="white"/>
    </svg>
  </div>
</div>
</div>
<button class="action-caption show-help-button">{{HELP_MODAL_NEED_HELP}}</button>
</div>
</div>`;
}

export function gateway() {
  return `
  <div data-jcs-element="provider__container" class="provider-container"></div>
<div class="button-container button-cancel-container button-gateway-container">
	<button data-jcs-element="cancel__journey" class="button button--secondary-destructive button-full-xs" aria-label="Button Title">
	{{CANCEL_JOURNEY}}
	</button>
	<button data-jcs-element="gateway__upload__toggle" class="button button--tertiary button--worker upload-photos-button" aria-label="Button Title">
		<div data-jcs-element="gateway__upload__toggle__upload__label">
			{{MANUAL_PHOTO_UPLOAD_TOGGLE_FALSE}}
		</div>
		<div data-jcs-element="gateway__upload__toggle__camera__label">
			{{MANUAL_PHOTO_UPLOAD_TOGGLE_TRUE}}
		</div>
	</button>
</div>
`
}
export function fileSystem() {
  return `<div class="light-inner-provider-container manual-upload">
	<div>
		<div data-jcs-element="identity__document__file__upload">
			<div class="preview-title-container">
				<h2 class="preview-title">{{PROVIDER_TITLE_FILESYSTEM_ID}}</h2>
				<span class="preview-description">{{PROVIDER_SUBTITLE_FILESYSTEM_ID}}</span>
			</div>
			<div class="show-mobile">
				<div class="preview-info-mobile-button" data-jcs-element="preview__page__open__info__id">
					<img class="preview-info-icon" src="assets/images/info-icon.svg" />
					<span class="preview-info-main-text">{{PREVIEW_INFO_TITLE_ID}}</span>
				</div>

				<div class="preview-info-inner-container" data-jcs-element="preview__info__container__id">
					<span class="preview-info-title">{{PREVIEW_INFO_TITLE_ID}}</span>
					<div class="id-example-container">
						<div class="id-example-container-row">
							<div class="id-example id-example-good">
								<img class="sample-image sample-image-success" src="assets/images/licence-good.svg" />
								<div class="separating-rectangle separating-rectangle-success"></div>
								<div class="preview-label preview-label-success">
									<img class="preview-label-icon" src="assets/images/green-check-icon.svg" />
									<span>{{PREVIEW_INFO_GOOD}}</span>
								</div>
								<span class="preview-info-example-text ">{{PREVIEW_INFO_GOOD_EXAMPLE_ID}}</span>
							</div>
							<div class="id-example id-example-angle-check">
								<img class="sample-image sample-image-error"
									src="assets/images/licence-bad-angle.svg" />
								<div class="separating-rectangle separating-rectangle-error"></div>
								<div class="preview-label preview-label-error">
									<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
									<span>{{PREVIEW_INFO_BAD}}</span>
								</div>
								<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_ANGLE_ID}}</span>
							</div>
						</div>
						<div class="id-example-container-row">
							<div class="id-example id-example-cover-check">
								<img class="sample-image sample-image-error"
									src="assets/images/licence-bad-covered.svg" />
								<div class="separating-rectangle separating-rectangle-error"></div>
								<div class="preview-label preview-label-error">
									<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
									<span>{{PREVIEW_INFO_BAD}}</span>
								</div>
								<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_COVER_ID}}</span>
							</div>
							<div class="id-example id-example-blur-check">
								<img class="sample-image sample-image-error"
									src="assets/images/licence-bad-blurred.svg" />
								<div class="separating-rectangle separating-rectangle-error"></div>
								<div class="preview-label preview-label-error">
									<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
									<span>{{PREVIEW_INFO_BAD}}</span>
								</div>
								<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_BLUR_ID}}</span>
							</div>
						</div>
					</div>
					<div class="modal-close-button close-preview-info-button"
						data-jcs-element="preview__page__close__info__id">
						<svg width="24" height="24" class="help-button-modal-close" viewBox="0 0 24 24" fill="none"
							xmlns="http://www.w3.org/2000/svg">
							<circle cx="12" cy="12" r="11" stroke-width="2" stroke-linecap="round" />
							<path d="M16 16L8 8M8 16L16 8" stroke-width="2" stroke-linecap="round"
								stroke-linejoin="round" />
						</svg>
						<p class="action-caption">{{REQUIRED_ACTION_Close}}</p>
					</div>
				</div>
			</div>
			<div class="show-desktop preview-info-container">
				<div class="preview-info-title">
					<img class="preview-info-icon" src="assets/images/info-icon.svg" />
					<span class="preview-info-main-text">{{PREVIEW_INFO_TITLE_ID}}</span>
				</div>
				<ul class="id-example-container">
					<li class="id-example id-example-good">
						<img class="sample-image sample-image-success" src="assets/images/licence-good.svg" />
						<div class="separating-rectangle separating-rectangle-success"></div>
						<div class="preview-label preview-label-success">
							<img class="preview-label-icon" src="assets/images/green-check-icon.svg" />
							<span>{{PREVIEW_INFO_GOOD}}</span>
						</div>
						<span class="preview-info-example-text ">{{PREVIEW_INFO_GOOD_EXAMPLE_ID}}</span>
					</li>
					<li class="id-example id-example-angle-check">
						<img class="sample-image sample-image-error" src="assets/images/licence-bad-angle.svg" />
						<div class="separating-rectangle separating-rectangle-error"></div>
						<div class="preview-label preview-label-error">
							<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
							<span>{{PREVIEW_INFO_BAD}}</span>
						</div>
						<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_ANGLE_ID}}</span>
					</li>
					<li class="id-example id-example-cover-check">
						<img class="sample-image sample-image-error" src="assets/images/licence-bad-covered.svg" />
						<div class="separating-rectangle separating-rectangle-error"></div>
						<div class="preview-label preview-label-error">
							<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
							<span>{{PREVIEW_INFO_BAD}}</span>
						</div>
						<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_COVER_ID}}</span>
					</li>
					<li class="id-example id-example-blur-check">
						<img class="sample-image sample-image-error" src="assets/images/licence-bad-blurred.svg" />
						<div class="separating-rectangle separating-rectangle-error"></div>
						<div class="preview-label preview-label-error">
							<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
							<span>{{PREVIEW_INFO_BAD}}</span>
						</div>
						<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_BLUR_ID}}</span>
					</li>
				</ul>
			</div>
			<div>
				<h3>{{FILESYSTEM_IDENTITY_DOCUMENT}} - <span data-jcs-element="info__journey__action"></h3>
			</div>
		</div>
		<div data-jcs-element="facematch__file__upload">
			<div class="preview-title-container">
				<h2>{{PROVIDER_TITLE_FILESYSTEM_FACEMATCH}}</h2>
				<span class="preview-description">{{PROVIDER_SUBTITLE_FILESYSTEM_FACEMATCH}}</span>
			</div>
			<div class="show-mobile">
				<div class="preview-info-mobile-button" data-jcs-element="preview__page__open__info__fm">
					<img class="preview-info-icon" src="assets/images/info-icon.svg" />
					<span class="preview-info-main-text">{{PREVIEW_INFO_TITLE_FACEMATCH}}</span>
				</div>

				<div class="preview-info-inner-container" data-jcs-element="preview__info__container__fm">
					<span class="preview-info-title">{{PREVIEW_INFO_TITLE_FACEMATCH}}</span>
					<div class="id-example-container">
						<div class="id-example-container-row">
							<div class="id-example id-example-good">
								<img class="sample-image sample-image-success" src="assets/images/selfie-good.svg" />
								<div class="separating-rectangle separating-rectangle-success"></div>
								<div class="preview-label preview-label-success">
									<img class="preview-label-icon" src="assets/images/green-check-icon.svg" />
									<span>{{PREVIEW_INFO_GOOD}}</span>
								</div>
								<span class="preview-info-example-text ">{{PREVIEW_INFO_GOOD_EXAMPLE_FACEMATCH}}</span>
							</div>
							<div class="id-example id-example-angle-check">
								<img class="sample-image sample-image-error" src="assets/images/selfie-partial.svg" />
								<div class="separating-rectangle separating-rectangle-error"></div>
								<div class="preview-label preview-label-error">
									<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
									<span>{{PREVIEW_INFO_BAD}}</span>
								</div>
								<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_ANGLE_FACEMATCH}}</span>
							</div>
						</div>
						<div class="id-example-container-row">
							<div class="id-example id-example-cover-check">
								<img class="sample-image sample-image-error" src="assets/images/selfie-glasses.svg" />
								<div class="separating-rectangle separating-rectangle-error"></div>
								<div class="preview-label preview-label-error">
									<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
									<span>{{PREVIEW_INFO_BAD}}</span>
								</div>
								<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_COVER_FACEMATCH}}</span>
							</div>
							<div class="id-example id-example-blur-check">
								<img class="sample-image sample-image-error" src="assets/images/selfie-blurred.svg" />
								<div class="separating-rectangle separating-rectangle-error"></div>
								<div class="preview-label preview-label-error">
									<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
									<span>{{PREVIEW_INFO_BAD}}</span>
								</div>
								<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_BLUR_FACEMATCH}}</span>
							</div>
						</div>
					</div>
					<div class="modal-close-button close-preview-info-button" data-jcs-element="preview__page__close__info__fm">
						<svg width="24" height="24" class="help-button-modal-close" viewBox="0 0 24 24" fill="none"
							xmlns="http://www.w3.org/2000/svg">
							<circle cx="12" cy="12" r="11" stroke-width="2" stroke-linecap="round" />
							<path d="M16 16L8 8M8 16L16 8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
						</svg>
						<p class="action-caption">{{REQUIRED_ACTION_Close}}</p>
					</div>
				</div>
			</div>
			<div class="show-desktop preview-info-container">
				<div class="preview-info-title">
					<img class="preview-info-icon" src="assets/images/info-icon.svg" />
					<span class="preview-info-main-text">{{PREVIEW_INFO_TITLE_FACEMATCH}}</span>
				</div>
				<ul class="id-example-container">
					<li class="id-example id-example-good">
						<img class="sample-image sample-image-success" src="assets/images/selfie-good.svg" />
						<div class="separating-rectangle separating-rectangle-success"></div>
						<div class="preview-label preview-label-success">
							<img class="preview-label-icon" src="assets/images/green-check-icon.svg" />
							<span>{{PREVIEW_INFO_GOOD}}</span>
						</div>
						<span class="preview-info-example-text ">{{PREVIEW_INFO_GOOD_EXAMPLE_FACEMATCH}}</span>
					</li>
					<li class="id-example id-example-angle-check">
						<img class="sample-image sample-image-error" src="assets/images/selfie-partial.svg" />
						<div class="separating-rectangle separating-rectangle-error"></div>
						<div class="preview-label preview-label-error">
							<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
							<span>{{PREVIEW_INFO_BAD}}</span>
						</div>
						<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_ANGLE_FACEMATCH}}</span>
					</li>
					<li class="id-example id-example-cover-check">
						<img class="sample-image sample-image-error" src="assets/images/selfie-glasses.svg" />
						<div class="separating-rectangle separating-rectangle-error"></div>
						<div class="preview-label preview-label-error">
							<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
							<span>{{PREVIEW_INFO_BAD}}</span>
						</div>
						<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_COVER_FACEMATCH}}</span>
					</li>
					<li class="id-example id-example-blur-check">
						<img class="sample-image sample-image-error" src="assets/images/selfie-blurred.svg" />
						<div class="separating-rectangle separating-rectangle-error"></div>
						<div class="preview-label preview-label-error">
							<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
							<span>{{PREVIEW_INFO_BAD}}</span>
						</div>
						<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_BLUR_FACEMATCH}}</span>
					</li>
				</ul>
			</div>
			<div>
				<h3><span>{{FILESYSTEM_FACEMATCH}}</span></h3>
			</div>
		</div>
		<div data-jcs-element="address__file__upload">
			<div class="preview-title-container">
				<h2>{{PROVIDER_TITLE_FILESYSTEM_ADDRESS}}</h2>
				<span class="preview-description">{{PROVIDER_SUBTITLE_FILESYSTEM_ADDRESS}}</span>
			</div>
			<div class="show-mobile">
				<div class="preview-info-mobile-button" data-jcs-element="preview__page__open__info__poa">
					<img class="preview-info-icon" src="assets/images/info-icon.svg" />
					<span class="preview-info-main-text">{{PREVIEW_INFO_TITLE_ADDRESS}}</span>
				</div>

				<div class="preview-info-inner-container" data-jcs-element="preview__info__container__poa">
					<span class="preview-info-title">{{PREVIEW_INFO_TITLE_ADDRESS}}</span>
					<div class="id-example-container">
						<div class="id-example-container-row">
							<div class="id-example id-example-good">
								<img class="sample-image sample-image-success" src="assets/images/address-good.svg" />
								<div class="separating-rectangle separating-rectangle-success"></div>
								<div class="preview-label preview-label-success">
									<img class="preview-label-icon" src="assets/images/green-check-icon.svg" />
									<span>{{PREVIEW_INFO_GOOD}}</span>
								</div>
								<span class="preview-info-example-text ">{{PREVIEW_INFO_GOOD_EXAMPLE_ADDRESS}}</span>
							</div>
							<div class="id-example id-example-angle-check">
								<img class="sample-image sample-image-error" src="assets/images/address-angled.svg" />
								<div class="separating-rectangle separating-rectangle-error"></div>
								<div class="preview-label preview-label-error">
									<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
									<span>{{PREVIEW_INFO_BAD}}</span>
								</div>
								<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_ANGLE_ADDRESS}}</span>
							</div>
						</div>
						<div class="id-example-container-row">
							<div class="id-example id-example-cover-check">
								<img class="sample-image sample-image-error" src="assets/images/address-covered.svg" />
								<div class="separating-rectangle separating-rectangle-error"></div>
								<div class="preview-label preview-label-error">
									<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
									<span>{{PREVIEW_INFO_BAD}}</span>
								</div>
								<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_COVER_ADDRESS}}</span>
							</div>
							<div class="id-example id-example-blur-check">
								<img class="sample-image sample-image-error" src="assets/images/address-blurred.svg" />
								<div class="separating-rectangle separating-rectangle-error"></div>
								<div class="preview-label preview-label-error">
									<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
									<span>{{PREVIEW_INFO_BAD}}</span>
								</div>
								<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_BLUR_ADDRESS}}</span>
							</div>
						</div>
					</div>
					<div class="modal-close-button close-preview-info-button" data-jcs-element="preview__page__close__info__poa">
						<svg width="24" height="24" class="help-button-modal-close" viewBox="0 0 24 24" fill="none"
							xmlns="http://www.w3.org/2000/svg">
							<circle cx="12" cy="12" r="11" stroke-width="2" stroke-linecap="round" />
							<path d="M16 16L8 8M8 16L16 8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
						</svg>
						<p class="action-caption">{{REQUIRED_ACTION_Close}}</p>
					</div>
				</div>
			</div>
			<div class="show-desktop preview-info-container">
				<div class="preview-info-title">
					<img class="preview-info-icon" src="assets/images/info-icon.svg" />
					<span class="preview-info-main-text">{{PREVIEW_INFO_TITLE_ADDRESS}}</span>
				</div>
				<ul class="id-example-container">
					<li class="id-example id-example-good">
						<img class="sample-image sample-image-success" src="assets/images/address-good.svg" />
						<div class="separating-rectangle separating-rectangle-success"></div>
						<div class="preview-label preview-label-success">
							<img class="preview-label-icon" src="assets/images/green-check-icon.svg" />
							<span>{{PREVIEW_INFO_GOOD}}</span>
						</div>
						<span class="preview-info-example-text ">{{PREVIEW_INFO_GOOD_EXAMPLE_ADDRESS}}</span>
					</li>
					<li class="id-example id-example-angle-check">
						<img class="sample-image sample-image-error" src="assets/images/address-angled.svg" />
						<div class="separating-rectangle separating-rectangle-error"></div>
						<div class="preview-label preview-label-error">
							<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
							<span>{{PREVIEW_INFO_BAD}}</span>
						</div>
						<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_ANGLE_ADDRESS}}</span>
					</li>
					<li class="id-example id-example-cover-check">
						<img class="sample-image sample-image-error" src="assets/images/address-covered.svg" />
						<div class="separating-rectangle separating-rectangle-error"></div>
						<div class="preview-label preview-label-error">
							<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
							<span>{{PREVIEW_INFO_BAD}}</span>
						</div>
						<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_COVER_ADDRESS}}</span>
					</li>
					<li class="id-example id-example-blur-check">
						<img class="sample-image sample-image-error" src="assets/images/address-blurred.svg" />
						<div class="separating-rectangle separating-rectangle-error"></div>
						<div class="preview-label preview-label-error">
							<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
							<span>{{PREVIEW_INFO_BAD}}</span>
						</div>
						<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_BLUR_ADDRESS}}</span>
					</li>
				</ul>
			</div>
			<div>
				<h3><span>{{FILESYSTEM_ADDRESS}}</span></h3>
			</div>
		</div>

<div data-jcs-element="covid__file__upload">
			<div class="preview-title-container">
				<h2>{{PROVIDER_TITLE_FILESYSTEM_COVID}}</h2>
				<span class="preview-description">{{PROVIDER_SUBTITLE_FILESYSTEM_COVID}}</span>
			</div>
			<div class="show-mobile">
				<div class="preview-info-mobile-button" data-jcs-element="preview__page__open__info__poa">
					<img class="preview-info-icon" src="assets/images/info-icon.svg" />
					<span class="preview-info-main-text">{{PREVIEW_INFO_TITLE_COVID}}</span>
				</div>

				<div class="preview-info-inner-container" data-jcs-element="preview__info__container__poa">
					<span class="preview-info-title">{{PREVIEW_INFO_TITLE_COVID}}</span>
					<div class="id-example-container">
						<div class="id-example-container-row">
							<div class="id-example id-example-good">
								<img class="sample-image sample-image-success" src="assets/images/address-good.svg" />
								<div class="separating-rectangle separating-rectangle-success"></div>
								<div class="preview-label preview-label-success">
									<img class="preview-label-icon" src="assets/images/green-check-icon.svg" />
									<span>{{PREVIEW_INFO_GOOD}}</span>
								</div>
								<span class="preview-info-example-text ">{{PREVIEW_INFO_GOOD_EXAMPLE_COVID}}</span>
							</div>
							<div class="id-example id-example-angle-check">
								<img class="sample-image sample-image-error" src="assets/images/address-angled.svg" />
								<div class="separating-rectangle separating-rectangle-error"></div>
								<div class="preview-label preview-label-error">
									<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
									<span>{{PREVIEW_INFO_BAD}}</span>
								</div>
								<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_ANGLE_COVID}}</span>
							</div>
						</div>
						<div class="id-example-container-row">
							<div class="id-example id-example-cover-check">
								<img class="sample-image sample-image-error" src="assets/images/address-covered.svg" />
								<div class="separating-rectangle separating-rectangle-error"></div>
								<div class="preview-label preview-label-error">
									<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
									<span>{{PREVIEW_INFO_BAD}}</span>
								</div>
								<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_COVER_COVID}}</span>
							</div>
							<div class="id-example id-example-blur-check">
								<img class="sample-image sample-image-error" src="assets/images/address-blurred.svg" />
								<div class="separating-rectangle separating-rectangle-error"></div>
								<div class="preview-label preview-label-error">
									<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
									<span>{{PREVIEW_INFO_BAD}}</span>
								</div>
								<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_BLUR_COVID}}</span>
							</div>
						</div>
					</div>
					<div class="modal-close-button close-preview-info-button" data-jcs-element="preview__page__close__info__poa">
						<svg width="24" height="24" class="help-button-modal-close" viewBox="0 0 24 24" fill="none"
							xmlns="http://www.w3.org/2000/svg">
							<circle cx="12" cy="12" r="11" stroke-width="2" stroke-linecap="round" />
							<path d="M16 16L8 8M8 16L16 8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
						</svg>
						<p class="action-caption">{{REQUIRED_ACTION_Close}}</p>
					</div>
				</div>
			</div>
			<div class="show-desktop preview-info-container">
				<div class="preview-info-title">
					<img class="preview-info-icon" src="assets/images/info-icon.svg" />
					<span class="preview-info-main-text">{{PREVIEW_INFO_TITLE_COVID}}</span>
				</div>
				<ul class="id-example-container">
					<li class="id-example id-example-good">
						<img class="sample-image sample-image-success" src="assets/images/address-good.svg" />
						<div class="separating-rectangle separating-rectangle-success"></div>
						<div class="preview-label preview-label-success">
							<img class="preview-label-icon" src="assets/images/green-check-icon.svg" />
							<span>{{PREVIEW_INFO_GOOD}}</span>
						</div>
						<span class="preview-info-example-text ">{{PREVIEW_INFO_GOOD_EXAMPLE_COVID}}</span>
					</li>
					<li class="id-example id-example-angle-check">
						<img class="sample-image sample-image-error" src="assets/images/address-angled.svg" />
						<div class="separating-rectangle separating-rectangle-error"></div>
						<div class="preview-label preview-label-error">
							<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
							<span>{{PREVIEW_INFO_BAD}}</span>
						</div>
						<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_ANGLE_COVID}}</span>
					</li>
					<li class="id-example id-example-cover-check">
						<img class="sample-image sample-image-error" src="assets/images/address-covered.svg" />
						<div class="separating-rectangle separating-rectangle-error"></div>
						<div class="preview-label preview-label-error">
							<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
							<span>{{PREVIEW_INFO_BAD}}</span>
						</div>
						<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_COVER_COVID}}</span>
					</li>
					<li class="id-example id-example-blur-check">
						<img class="sample-image sample-image-error" src="assets/images/address-blurred.svg" />
						<div class="separating-rectangle separating-rectangle-error"></div>
						<div class="preview-label preview-label-error">
							<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
							<span>{{PREVIEW_INFO_BAD}}</span>
						</div>
						<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_BLUR_COVID}}</span>
					</li>
				</ul>
			</div>
			<div>
				<h3><span>{{FILESYSTEM_COVID}}</span></h3>
			</div>
		</div>

		<div>
			<div class="check-error-color" data-jcs-element="file__too__large__error">
        <svg width="65" height="57" viewBox="0 0 65 57" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M64.614 53.0505L34.7585 1.30534C33.7544 -0.435114 31.2106 -0.435114 30.2065 1.30534L0.350953 53.0505C-0.653157 54.791 0.618716 57 2.62694 57H62.405C64.4132 57 65.6851 54.791 64.614 53.0505ZM35.6956 49.9712H29.2024V43.478H35.6956V49.9712ZM35.7626 39.4615H29.1355V17.505H35.7626V39.4615Z" fill="#FFB800"/>
        </svg>
        <p class="check-error-color">
          {{FILESYSTEM_CHECK_FILE_TOO_BIG}}
        </p> 
			</div>
      <div class="check-error-color" data-jcs-element="invalid__format__error">
        <svg width="65" height="57" viewBox="0 0 65 57" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M64.614 53.0505L34.7585 1.30534C33.7544 -0.435114 31.2106 -0.435114 30.2065 1.30534L0.350953 53.0505C-0.653157 54.791 0.618716 57 2.62694 57H62.405C64.4132 57 65.6851 54.791 64.614 53.0505ZM35.6956 49.9712H29.2024V43.478H35.6956V49.9712ZM35.7626 39.4615H29.1355V17.505H35.7626V39.4615Z" fill="#FFB800"/>
        </svg>
        <p class="check-error-color">
          {{FILESYSTEM_CHECK_FILE_INCORRECT_FORMAT}}  
        </p>
      </div>
			<p data-jcs-element="uploading__file__without__preview">{{FILESYSTEM_UPLOADING}}</p>
		</div>

    <div class="notification notification-blue" data-jcs-element="attempt__count__container">
      <div class="notification-container">
        <svg xmlns="http://www.w3.org/2000/svg" width="65" height="57" viewBox="0 0 65 57" fill="none">
          <path d="M64.614 53.0505L34.7585 1.30534C33.7544 -0.435114 31.2106 -0.435114 30.2065 1.30534L0.350953 53.0505C-0.653157 54.791 0.618716 57 2.62694 57H62.405C64.4132 57 65.6851 54.791 64.614 53.0505ZM35.6956 49.9712H29.2024V43.478H35.6956V49.9712ZM35.7626 39.4615H29.1355V17.505H35.7626V39.4615Z" fill="#FFB800"/>
        </svg>
        <p class="notification-counter">{{ATTEMPTS_REMAINING}} <span
            data-jcs-element="attempt__counter"></span>{{PREVIEW_ATTEMPT_NUMBER_END}}</p>
      </div>
    </div>

		<div class="file-upload-container" data-jcs-element="file__drop__box">
			<form class="file-input--container">
				<input data-jcs-element="file__input" class="file-input" id="jcs__file__input" type="file" />
			</form>
			<div class="drag-and-drop-container">
					<svg xmlns="http://www.w3.org/2000/svg" width="40" height="29" viewBox="0 0 40 29" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M29.6562 10.8818L28.7665 10.7629L28.6689 9.94021C28.6326 9.64677 27.685 2.69665 20.1413 2.69665C12.5278 2.69665 11.4568 9.32942 11.4157 9.61129L11.2898 10.4601L10.3625 10.532C10.0372 10.5594 2.32366 11.2714 2.32366 17.8421C2.32366 25.0226 8.96033 26.2692 9.77258 26.3946H28.856C29.1646 26.3925 36.5179 26.2701 37.1884 19.1742C37.8591 12.0646 29.9917 10.9268 29.6558 10.8819L29.6562 10.8818ZM39.5039 19.3604C38.8184 26.6158 32.239 28.5329 28.8564 28.5329L9.5266 28.5236C9.43128 28.5111 0 27.2197 0 17.8423C0 11.5449 5.6412 9.07357 9.27948 8.50697C10.0803 5.36954 13.0924 0.558899 20.1416 0.558899C27.2532 0.558899 30.1431 5.64119 30.8469 8.91499C34.5328 9.698 40.1399 12.6275 39.5043 19.3604L39.5039 19.3604ZM24.6994 10.9039C25.153 11.3216 25.153 11.9981 24.6994 12.4154C24.4726 12.6246 24.1752 12.7289 23.8777 12.7289C23.5807 12.7289 23.2832 12.6246 23.0564 12.4154L21.0456 10.5656V22.3412C21.0456 22.9321 20.526 23.4103 19.8836 23.4103C19.2413 23.4103 18.7216 22.9321 18.7216 22.3412V10.5656L16.7104 12.4154C16.4835 12.6246 16.1865 12.7289 15.889 12.7289C15.5915 12.7289 15.2945 12.6246 15.0672 12.4154C14.6136 11.9981 14.6136 11.3216 15.0672 10.9039L19.0603 7.23058C19.1676 7.13147 19.2964 7.05268 19.4395 6.99798C19.7235 6.89024 20.0429 6.89024 20.3269 6.99798C20.47 7.05268 20.5988 7.13147 20.7062 7.23058L24.6994 10.9039Z" fill="#00D37E"/>
          </svg>
				<span class="color-gray">{{FILESYSTEM_DRAG_DROP}}</span>
				<span class="color-gray">{{FILESYSTEM_OR}}</span>
			</div>
			<button class="button button--secondary"
				onclick="document.getElementById('jcs__file__input').click()">
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="20" viewBox="0 0 19 20" fill="none">
          <path d="M11.2493 0H3.74976C2.75503 0 1.80197 0.395808 1.09889 1.09889C0.395808 1.80197 0 2.75503 0 3.74976V16.2489C0 17.2437 0.395808 18.1967 1.09889 18.8998C1.80197 19.6029 2.75503 19.9987 3.74976 19.9987H6.56207C7.00736 19.9987 7.42139 19.7617 7.64534 19.3737C7.86928 18.9857 7.86928 18.5118 7.64534 18.1238C7.42139 17.7358 7.00996 17.4989 6.56207 17.4989H3.74976C3.41905 17.4989 3.10136 17.3661 2.867 17.1317C2.63264 16.8973 2.49984 16.5797 2.49984 16.2489V3.81746C2.49203 3.46592 2.63004 3.1274 2.87742 2.88002C3.1248 2.63264 3.46332 2.49463 3.81225 2.49984C4.13254 2.51546 4.43461 2.65347 4.65595 2.88783C4.87729 3.11959 4.99968 3.42946 4.99968 3.74976C4.99968 4.08046 5.13248 4.39815 5.36684 4.63251C5.6012 4.86687 5.91889 4.99967 6.24959 4.99967H8.74943C9.08014 4.99967 9.39783 4.86687 9.63219 4.63251C9.86655 4.39815 9.99935 4.08046 9.99935 3.74976C9.99935 3.42946 10.1217 3.11959 10.3431 2.88783C10.5644 2.65608 10.8665 2.51546 11.1868 2.49984C11.5383 2.49463 11.8742 2.63264 12.1216 2.88002C12.369 3.1274 12.5044 3.46592 12.4992 3.81746V7.81199C12.4992 8.25728 12.7362 8.67131 13.1241 8.89525C13.5121 9.1192 13.9861 9.1192 14.3741 8.89525C14.7621 8.67131 14.999 8.25988 14.999 7.81199V3.74976C14.999 2.75503 14.6032 1.80197 13.9001 1.09889C13.1971 0.395808 12.244 0 11.2493 0Z" fill="#00D37E"/>
          <path d="M14.999 12.4991C14.999 12.0539 14.762 11.6398 14.374 11.4159C13.986 11.1919 13.5121 11.1919 13.1241 11.4159C12.7361 11.6398 12.4991 12.0513 12.4991 12.4991V14.374H10.6243C10.179 14.374 9.76495 14.611 9.541 14.999C9.31706 15.387 9.31706 15.8609 9.541 16.2489C9.76495 16.6369 10.1764 16.8739 10.6243 16.8739H12.4991V18.7487C12.4991 19.194 12.7361 19.6081 13.1241 19.832C13.5121 20.0559 13.986 20.0559 14.374 19.832C14.762 19.6081 14.999 19.1966 14.999 18.7487V16.8739H16.8739C17.3191 16.8739 17.7332 16.6369 17.9571 16.2489C18.1811 15.8609 18.1811 15.387 17.9571 14.999C17.7332 14.611 17.3217 14.374 16.8739 14.374H14.999V12.4991Z" fill="#00D37E"/>
          <path d="M7.49952 3.43728C8.08916 3.43728 8.56716 2.95928 8.56716 2.36964C8.56716 1.78 8.08916 1.302 7.49952 1.302C6.90988 1.302 6.43188 1.78 6.43188 2.36964C6.43188 2.95928 6.90988 3.43728 7.49952 3.43728Z" fill="#1A2242"/>
        </svg>
        {{FILESYSTEM_CHOOSE}}
        </button>
		</div>
    <div>
			<p class="color-gray">{{FILESYSTEM_SUPPORTED_TYPES_FIRST}} <i>{{FILESYSTEM_SUPPORTED_TYPES_LIST}} </i>{{FILESYSTEM_SUPPORTED_TYPES_SECOND}} <i>{{FILESYSTEM_SUPPORTED_TYPES_PDF}} </i>{{FILESYSTEM_SUPPORTED_TYPES_THIRD}}</p>
			<p class="color-gray">{{FILESYSTEM_MAX_FILE_SIZE}} <i>{{FILESYSTEM_MAX_FILE_SIZE_NUMBER}}</i></p>
		</div>
	</div>
</div>`
}

export function view() {
  return `
  <div class="light-inner-provider-container">
	<div>
		<div data-jcs-element="identity__document__preview">
			<div class="preview-title-container">
				<h2 class="preview-title">{{PROVIDER_TITLE_VIEW_ID}}</h2>
				<span class="preview-description">{{PROVIDER_SUBTITLE_VIEW_ID}}</span>
			</div>
			<div class="show-mobile">
				<div class="preview-info-mobile-button" data-jcs-element="preview__page__open__info__id">
					<img class="preview-info-icon" src="assets/images/info-icon.svg" />
					<span class="preview-info-main-text">{{PREVIEW_INFO_TITLE_ID}}</span>
				</div>

				<div class="preview-info-inner-container" data-jcs-element="preview__info__container__id">
					<span class="preview-info-title">{{PREVIEW_INFO_TITLE_ID}}</span>
					<div class="id-example-container">
						<div class="id-example-container-row">
							<div class="id-example id-example-good">
								<img class="sample-image sample-image-success" src="assets/images/licence-good.svg" />
								<div class="separating-rectangle separating-rectangle-success"></div>
								<div class="preview-label preview-label-success">
									<img class="preview-label-icon" src="assets/images/green-check-icon.svg" />
									<span>{{PREVIEW_INFO_GOOD}}</span>
								</div>
								<span class="preview-info-example-text ">{{PREVIEW_INFO_GOOD_EXAMPLE_ID}}</span>
							</div>
							<div class="id-example id-example-angle-check">
								<img class="sample-image sample-image-error"
									src="assets/images/licence-bad-angle.svg" />
								<div class="separating-rectangle separating-rectangle-error"></div>
								<div class="preview-label preview-label-error">
									<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
									<span>{{PREVIEW_INFO_BAD}}</span>
								</div>
								<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_ANGLE_ID}}</span>
							</div>
						</div>
						<div class="id-example-container-row">
							<div class="id-example id-example-cover-check">
								<img class="sample-image sample-image-error"
									src="assets/images/licence-bad-covered.svg" />
								<div class="separating-rectangle separating-rectangle-error"></div>
								<div class="preview-label preview-label-error">
									<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
									<span>{{PREVIEW_INFO_BAD}}</span>
								</div>
								<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_COVER_ID}}</span>
							</div>
							<div class="id-example id-example-blur-check">
								<img class="sample-image sample-image-error"
									src="assets/images/licence-bad-blurred.svg" />
								<div class="separating-rectangle separating-rectangle-error"></div>
								<div class="preview-label preview-label-error">
									<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
									<span>{{PREVIEW_INFO_BAD}}</span>
								</div>
								<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_BLUR_ID}}</span>
							</div>
						</div>
					</div>
					<div class="modal-close-button close-preview-info-button"
						data-jcs-element="preview__page__close__info__id">
						<svg width="24" height="24" class="help-button-modal-close" viewBox="0 0 24 24" fill="none"
							xmlns="http://www.w3.org/2000/svg">
							<circle cx="12" cy="12" r="11" stroke-width="2" stroke-linecap="round" />
							<path d="M16 16L8 8M8 16L16 8" stroke-width="2" stroke-linecap="round"
								stroke-linejoin="round" />
						</svg>
						<p class="action-caption">{{REQUIRED_ACTION_Close}}</p>
					</div>
				</div>
			</div>

			<div class="show-desktop preview-info-container">
				<div class="preview-info-title">
					<img class="preview-info-icon" src="assets/images/info-icon.svg" />
					<span class="preview-info-main-text">{{PREVIEW_INFO_TITLE_ID}}</span>
				</div>
				<ul class="id-example-container">
					<li class="id-example id-example-good">
						<img class="sample-image sample-image-success" src="assets/images/licence-good.svg" />
						<div class="separating-rectangle separating-rectangle-success"></div>
						<div class="preview-label preview-label-success">
							<img class="preview-label-icon" src="assets/images/green-check-icon.svg" />
							<span>{{PREVIEW_INFO_GOOD}}</span>
						</div>
						<span class="preview-info-example-text ">{{PREVIEW_INFO_GOOD_EXAMPLE_ID}}</span>
					</li>
					<li class="id-example id-example-angle-check">
						<img class="sample-image sample-image-error" src="assets/images/licence-bad-angle.svg" />
						<div class="separating-rectangle separating-rectangle-error"></div>
						<div class="preview-label preview-label-error">
							<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
							<span>{{PREVIEW_INFO_BAD}}</span>
						</div>
						<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_ANGLE_ID}}</span>
					</li>
					<li class="id-example id-example-cover-check">
						<img class="sample-image sample-image-error" src="assets/images/licence-bad-covered.svg" />
						<div class="separating-rectangle separating-rectangle-error"></div>
						<div class="preview-label preview-label-error">
							<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
							<span>{{PREVIEW_INFO_BAD}}</span>
						</div>
						<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_COVER_ID}}</span>
					</li>
					<li class="id-example id-example-blur-check">
						<img class="sample-image sample-image-error" src="assets/images/licence-bad-blurred.svg" />
						<div class="separating-rectangle separating-rectangle-error"></div>
						<div class="preview-label preview-label-error">
							<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
							<span>{{PREVIEW_INFO_BAD}}</span>
						</div>
						<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_BLUR_ID}}</span>
					</li>
				</ul>
			</div>
		</div>
		<div data-jcs-element="facematch__preview">
			<div class="preview-title-container">
				<h2>{{PROVIDER_TITLE_VIEW_FACEMATCH}}</h2>
				<span class="preview-description">{{PROVIDER_SUBTITLE_VIEW_FACEMATCH}}</span>
			</div>
			<div class="show-mobile">
				<div class="preview-info-mobile-button" data-jcs-element="preview__page__open__info__fm">
					<img class="preview-info-icon" src="assets/images/info-icon.svg" />
					<span class="preview-info-main-text">{{PREVIEW_INFO_TITLE_FACEMATCH}}</span>
				</div>

				<div class="preview-info-inner-container" data-jcs-element="preview__info__container__fm">
					<span class="preview-info-title">{{PREVIEW_INFO_TITLE_FACEMATCH}}</span>
					<div class="id-example-container">
						<div class="id-example-container-row">
							<div class="id-example id-example-good">
								<img class="sample-image sample-image-success" src="assets/images/selfie-good.svg" />
								<div class="separating-rectangle separating-rectangle-success"></div>
								<div class="preview-label preview-label-success">
									<img class="preview-label-icon" src="assets/images/green-check-icon.svg" />
									<span>{{PREVIEW_INFO_GOOD}}</span>
								</div>
								<span class="preview-info-example-text ">{{PREVIEW_INFO_GOOD_EXAMPLE_FACEMATCH}}</span>
							</div>
							<div class="id-example id-example-angle-check">
								<img class="sample-image sample-image-error" src="assets/images/selfie-partial.svg" />
								<div class="separating-rectangle separating-rectangle-error"></div>
								<div class="preview-label preview-label-error">
									<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
									<span>{{PREVIEW_INFO_BAD}}</span>
								</div>
								<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_ANGLE_FACEMATCH}}</span>
							</div>
						</div>
						<div class="id-example-container-row">
							<div class="id-example id-example-cover-check">
								<img class="sample-image sample-image-error" src="assets/images/selfie-glasses.svg" />
								<div class="separating-rectangle separating-rectangle-error"></div>
								<div class="preview-label preview-label-error">
									<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
									<span>{{PREVIEW_INFO_BAD}}</span>
								</div>
								<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_COVER_FACEMATCH}}</span>
							</div>
							<div class="id-example id-example-blur-check">
								<img class="sample-image sample-image-error" src="assets/images/selfie-blurred.svg" />
								<div class="separating-rectangle separating-rectangle-error"></div>
								<div class="preview-label preview-label-error">
									<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
									<span>{{PREVIEW_INFO_BAD}}</span>
								</div>
								<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_BLUR_FACEMATCH}}</span>
							</div>
						</div>
					</div>
					<div class="modal-close-button close-preview-info-button" data-jcs-element="preview__page__close__info__fm">
						<svg width="24" height="24" class="help-button-modal-close" viewBox="0 0 24 24" fill="none"
							xmlns="http://www.w3.org/2000/svg">
							<circle cx="12" cy="12" r="11" stroke-width="2" stroke-linecap="round" />
							<path d="M16 16L8 8M8 16L16 8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
						</svg>
						<p class="action-caption">{{REQUIRED_ACTION_Close}}</p>
					</div>
				</div>
			</div>
			<div class="show-desktop preview-info-container">
				<div class="preview-info-title">
					<img class="preview-info-icon" src="assets/images/info-icon.svg" />
					<span class="preview-info-main-text">{{PREVIEW_INFO_TITLE_FACEMATCH}}</span>
				</div>
				<ul class="id-example-container">
					<li class="id-example id-example-good">
						<img class="sample-image sample-image-success" src="assets/images/selfie-good.svg" />
						<div class="separating-rectangle separating-rectangle-success"></div>
						<div class="preview-label preview-label-success">
							<img class="preview-label-icon" src="assets/images/green-check-icon.svg" />
							<span>{{PREVIEW_INFO_GOOD}}</span>
						</div>
						<span class="preview-info-example-text ">{{PREVIEW_INFO_GOOD_EXAMPLE_FACEMATCH}}</span>
					</li>
					<li class="id-example id-example-angle-check">
						<img class="sample-image sample-image-error" src="assets/images/selfie-partial.svg" />
						<div class="separating-rectangle separating-rectangle-error"></div>
						<div class="preview-label preview-label-error">
							<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
							<span>{{PREVIEW_INFO_BAD}}</span>
						</div>
						<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_ANGLE_FACEMATCH}}</span>
					</li>
					<li class="id-example id-example-cover-check">
						<img class="sample-image sample-image-error" src="assets/images/selfie-glasses.svg" />
						<div class="separating-rectangle separating-rectangle-error"></div>
						<div class="preview-label preview-label-error">
							<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
							<span>{{PREVIEW_INFO_BAD}}</span>
						</div>
						<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_COVER_FACEMATCH}}</span>
					</li>
					<li class="id-example id-example-blur-check">
						<img class="sample-image sample-image-error" src="assets/images/selfie-blurred.svg" />
						<div class="separating-rectangle separating-rectangle-error"></div>
						<div class="preview-label preview-label-error">
							<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
							<span>{{PREVIEW_INFO_BAD}}</span>
						</div>
						<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_BLUR_FACEMATCH}}</span>
					</li>
				</ul>
			</div>
		</div>
		<div data-jcs-element="address__preview">
			<div class="preview-title-container">
				<h2>{{PROVIDER_TITLE_VIEW_ADDRESS}}</h2>
				<span class="preview-description">{{PROVIDER_SUBTITLE_VIEW_ADDRESS}}</span>
			</div>
			<div class="show-mobile">
				<div class="preview-info-mobile-button" data-jcs-element="preview__page__open__info__poa">
					<img class="preview-info-icon" src="assets/images/info-icon.svg" />
					<span class="preview-info-main-text">{{PREVIEW_INFO_TITLE_ADDRESS}}</span>
				</div>

				<div class="preview-info-inner-container" data-jcs-element="preview__info__container__poa">
					<span class="preview-info-title">{{PREVIEW_INFO_TITLE_ADDRESS}}</span>
					<div class="id-example-container">
						<div class="id-example-container-row">
							<div class="id-example id-example-good">
								<img class="sample-image sample-image-success" src="assets/images/address-good.svg" />
								<div class="separating-rectangle separating-rectangle-success"></div>
								<div class="preview-label preview-label-success">
									<img class="preview-label-icon" src="assets/images/green-check-icon.svg" />
									<span>{{PREVIEW_INFO_GOOD}}</span>
								</div>
								<span class="preview-info-example-text ">{{PREVIEW_INFO_GOOD_EXAMPLE_ADDRESS}}</span>
							</div>
							<div class="id-example id-example-angle-check">
								<img class="sample-image sample-image-error" src="assets/images/address-angled.svg" />
								<div class="separating-rectangle separating-rectangle-error"></div>
								<div class="preview-label preview-label-error">
									<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
									<span>{{PREVIEW_INFO_BAD}}</span>
								</div>
								<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_ANGLE_ADDRESS}}</span>
							</div>
						</div>
						<div class="id-example-container-row">
							<div class="id-example id-example-cover-check">
								<img class="sample-image sample-image-error" src="assets/images/address-covered.svg" />
								<div class="separating-rectangle separating-rectangle-error"></div>
								<div class="preview-label preview-label-error">
									<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
									<span>{{PREVIEW_INFO_BAD}}</span>
								</div>
								<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_COVER_ADDRESS}}</span>
							</div>
							<div class="id-example id-example-blur-check">
								<img class="sample-image sample-image-error" src="assets/images/address-blurred.svg" />
								<div class="separating-rectangle separating-rectangle-error"></div>
								<div class="preview-label preview-label-error">
									<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
									<span>{{PREVIEW_INFO_BAD}}</span>
								</div>
								<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_BLUR_ADDRESS}}</span>
							</div>
						</div>
					</div>
					<div class="modal-close-button close-preview-info-button" data-jcs-element="preview__page__close__info__poa">
						<svg width="24" height="24" class="help-button-modal-close" viewBox="0 0 24 24" fill="none"
							xmlns="http://www.w3.org/2000/svg">
							<circle cx="12" cy="12" r="11" stroke-width="2" stroke-linecap="round" />
							<path d="M16 16L8 8M8 16L16 8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
						</svg>
						<p class="action-caption">{{REQUIRED_ACTION_Close}}</p>
					</div>
				</div>
			</div>
			<div class="show-desktop preview-info-container">
				<div class="preview-info-title">
					<img class="preview-info-icon" src="assets/images/info-icon.svg" />
					<span class="preview-info-main-text">{{PREVIEW_INFO_TITLE_ADDRESS}}</span>
				</div>
				<ul class="id-example-container">
					<li class="id-example id-example-good">
						<img class="sample-image sample-image-success" src="assets/images/address-good.svg" />
						<div class="separating-rectangle separating-rectangle-success"></div>
						<div class="preview-label preview-label-success">
							<img class="preview-label-icon" src="assets/images/green-check-icon.svg" />
							<span>{{PREVIEW_INFO_GOOD}}</span>
						</div>
						<span class="preview-info-example-text ">{{PREVIEW_INFO_GOOD_EXAMPLE_ADDRESS}}</span>
					</li>
					<li class="id-example id-example-angle-check">
						<img class="sample-image sample-image-error" src="assets/images/address-angled.svg" />
						<div class="separating-rectangle separating-rectangle-error"></div>
						<div class="preview-label preview-label-error">
							<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
							<span>{{PREVIEW_INFO_BAD}}</span>
						</div>
						<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_ANGLE_ADDRESS}}</span>
					</li>
					<li class="id-example id-example-cover-check">
						<img class="sample-image sample-image-error" src="assets/images/address-covered.svg" />
						<div class="separating-rectangle separating-rectangle-error"></div>
						<div class="preview-label preview-label-error">
							<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
							<span>{{PREVIEW_INFO_BAD}}</span>
						</div>
						<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_COVER_ADDRESS}}</span>
					</li>
					<li class="id-example id-example-blur-check">
						<img class="sample-image sample-image-error" src="assets/images/address-blurred.svg" />
						<div class="separating-rectangle separating-rectangle-error"></div>
						<div class="preview-label preview-label-error">
							<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
							<span>{{PREVIEW_INFO_BAD}}</span>
						</div>
						<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_BLUR_ADDRESS}}</span>
					</li>
				</ul>
			</div>
		</div>

<div data-jcs-element="covid__preview">
			<div class="preview-title-container">
				<h2>{{PROVIDER_TITLE_VIEW_COVID}}</h2>
				<span class="preview-description">{{PROVIDER_SUBTITLE_VIEW_COVID}}</span>
			</div>
			<div class="show-mobile">
				<div class="preview-info-mobile-button" data-jcs-element="preview__page__open__info__covid">
					<img class="preview-info-icon" src="assets/images/info-icon.svg" />
					<span class="preview-info-main-text">{{PREVIEW_INFO_TITLE_COVID}}</span>
				</div>

				<div class="preview-info-inner-container" data-jcs-element="preview__info__container__covid">
					<span class="preview-info-title">{{PREVIEW_INFO_TITLE_COVID}}</span>
					<div class="id-example-container">
						<div class="id-example-container-row">
							<div class="id-example id-example-good">
								<img class="sample-image sample-image-success" src="assets/images/address-good.svg" />
								<div class="separating-rectangle separating-rectangle-success"></div>
								<div class="preview-label preview-label-success">
									<img class="preview-label-icon" src="assets/images/green-check-icon.svg" />
									<span>{{PREVIEW_INFO_GOOD}}</span>
								</div>
								<span class="preview-info-example-text ">{{PREVIEW_INFO_GOOD_EXAMPLE_COVID}}</span>
							</div>
							<div class="id-example id-example-angle-check">
								<img class="sample-image sample-image-error" src="assets/images/address-angled.svg" />
								<div class="separating-rectangle separating-rectangle-error"></div>
								<div class="preview-label preview-label-error">
									<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
									<span>{{PREVIEW_INFO_BAD}}</span>
								</div>
								<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_ANGLE_COVID}}</span>
							</div>
						</div>
						<div class="id-example-container-row">
							<div class="id-example id-example-cover-check">
								<img class="sample-image sample-image-error" src="assets/images/address-covered.svg" />
								<div class="separating-rectangle separating-rectangle-error"></div>
								<div class="preview-label preview-label-error">
									<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
									<span>{{PREVIEW_INFO_BAD}}</span>
								</div>
								<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_COVER_COVID}}</span>
							</div>
							<div class="id-example id-example-blur-check">
								<img class="sample-image sample-image-error" src="assets/images/address-blurred.svg" />
								<div class="separating-rectangle separating-rectangle-error"></div>
								<div class="preview-label preview-label-error">
									<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
									<span>{{PREVIEW_INFO_BAD}}</span>
								</div>
								<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_BLUR_COVID}}</span>
							</div>
						</div>
					</div>
					<div class="modal-close-button close-preview-info-button" data-jcs-element="preview__page__close__info__covid">
						<svg width="24" height="24" class="help-button-modal-close" viewBox="0 0 24 24" fill="none"
							xmlns="http://www.w3.org/2000/svg">
							<circle cx="12" cy="12" r="11" stroke-width="2" stroke-linecap="round" />
							<path d="M16 16L8 8M8 16L16 8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
						</svg>
						<p class="action-caption">{{REQUIRED_ACTION_Close}}</p>
					</div>
				</div>
			</div>
			<div class="show-desktop preview-info-container">
				<div class="preview-info-title">
					<img class="preview-info-icon" src="assets/images/info-icon.svg" />
					<span class="preview-info-main-text">{{PREVIEW_INFO_TITLE_COVID}}</span>
				</div>
				<ul class="id-example-container">
					<li class="id-example id-example-good">
						<img class="sample-image sample-image-success" src="assets/images/address-good.svg" />
						<div class="separating-rectangle separating-rectangle-success"></div>
						<div class="preview-label preview-label-success">
							<img class="preview-label-icon" src="assets/images/green-check-icon.svg" />
							<span>{{PREVIEW_INFO_GOOD}}</span>
						</div>
						<span class="preview-info-example-text ">{{PREVIEW_INFO_GOOD_EXAMPLE_COVID}}</span>
					</li>
					<li class="id-example id-example-angle-check">
						<img class="sample-image sample-image-error" src="assets/images/address-angled.svg" />
						<div class="separating-rectangle separating-rectangle-error"></div>
						<div class="preview-label preview-label-error">
							<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
							<span>{{PREVIEW_INFO_BAD}}</span>
						</div>
						<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_ANGLE_COVID}}</span>
					</li>
					<li class="id-example id-example-cover-check">
						<img class="sample-image sample-image-error" src="assets/images/address-covered.svg" />
						<div class="separating-rectangle separating-rectangle-error"></div>
						<div class="preview-label preview-label-error">
							<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
							<span>{{PREVIEW_INFO_BAD}}</span>
						</div>
						<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_COVER_COVID}}</span>
					</li>
					<li class="id-example id-example-blur-check">
						<img class="sample-image sample-image-error" src="assets/images/address-blurred.svg" />
						<div class="separating-rectangle separating-rectangle-error"></div>
						<div class="preview-label preview-label-error">
							<img class="preview-label-icon" src="assets/images/red-x-icon.svg" />
							<span>{{PREVIEW_INFO_BAD}}</span>
						</div>
						<span class="preview-info-example-text ">{{PREVIEW_INFO_BAD_EXAMPLE_BLUR_COVID}}</span>
					</li>
				</ul>
			</div>
		</div>

    <div class="notification notification-blue" data-jcs-element="attempt__count__container">
      <div class="notification-container">
        <div class="system-not-able">
          <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="17" cy="17" r="16.2273" stroke="#FAB313" stroke-width="1.54545"/>
            <path d="M17.4281 20.7078H16.0019L15.3091 6.32328H18.1208L17.4281 20.7078ZM15.0646 24.742C15.0646 23.5104 15.608 22.8947 16.6946 22.8947C17.2198 22.8947 17.6228 23.0531 17.9035 23.3701C18.1933 23.687 18.3382 24.1443 18.3382 24.742C18.3382 25.3215 18.1933 25.7743 17.9035 26.1003C17.6137 26.4172 17.2108 26.5757 16.6946 26.5757C16.2237 26.5757 15.8343 26.4353 15.5265 26.1546C15.2186 25.8648 15.0646 25.3939 15.0646 24.742Z" fill="#FAB313"/>
          </svg>   
          <p>{{SYSTEM_NOT_ABLE}}</p>
        </div>
        <p class="notification-counter">{{ATTEMPTS_REMAINING}} <span
            data-jcs-element="attempt__counter"></span>{{PREVIEW_ATTEMPT_NUMBER_END}}</p>
      </div>
    </div>
		
		<div class="image-preview--container image-preview-container">
			<img data-jcs-element="view__preview" class="image-preview">
			<div data-jcs-element="overlay_viewfinder" class="camera-viewfinder--overlay--transparent">
				<div class="loading-animation-container" data-jcs-element="loading-animation">
				</div>
        <div class="gbg-loader">
          <svg class="circular" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="3" stroke-miterlimit="10" />
          </svg>
          <p>{{PICTURE_VERIFYING}}</p>
        </div>
			</div>
		</div>
		<div class="button-container button-actions-container">
      <button data-jcs-element="view__upload" class="button button--primary button-full-xs"
      aria-label="{{VIEW_UPLOAD}}">
      {{VIEW_UPLOAD}}
      </button>
      <button data-jcs-element="view__retry" class="button button--secondary button-full-xs"
      aria-label="{{VIEW_RETRY}}">
        {{VIEW_RETRY}}
      </button>
		</div>
		<div data-jcs-element="view__status">
			<p data-jcs-element="view__status__message"></p>
		</div>
	</div>
</div>
`
}

export function result() {
  return `
  <svg class="circular" viewBox="25 25 50 50">
    <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="3" stroke-miterlimit="10" />
  </svg>
`
}

export function initializing() {
  return `
  <div class="loaderinit"></div>
`
}